/**
 * Wilderness RV Mattress - Custom Builder V2
 * Modular JavaScript for Shopify Integration
 */
(function() {
  'use strict';
  
  // Error tracking
  var builderErrors = [];
  var checkoutEnabled = true;
  
  function logError(errorType, details) {
    var error = {
      type: errorType,
      details: details,
      timestamp: new Date().toISOString(),
      state: JSON.parse(JSON.stringify(S)), // Copy current state
      url: window.location.href,
      userAgent: navigator.userAgent
    };
    builderErrors.push(error);
    checkoutEnabled = false;
    
    console.error('Builder Error:', error);
    
    // Update UI to show error state
    updateErrorUI(errorType, details);
    
    // Send notification
    sendErrorNotification(error);
  }
  
  function updateErrorUI(errorType, details) {
    var cartBtn = document.getElementById('btnCart');
    if (cartBtn) {
      cartBtn.disabled = true;
      cartBtn.style.opacity = '0.5';
      cartBtn.style.cursor = 'not-allowed';
    }
    
    // Show error message to user
    var errorMsg = document.getElementById('builderErrorMsg');
    if (!errorMsg) {
      errorMsg = document.createElement('div');
      errorMsg.id = 'builderErrorMsg';
      errorMsg.style.cssText = 'background:#fee;border:2px solid #c00;color:#900;padding:16px;border-radius:8px;margin:16px 0;text-align:center;';
      var stepCont = document.querySelector('.step-cont');
      if (stepCont) stepCont.insertBefore(errorMsg, stepCont.firstChild);
    }
    errorMsg.innerHTML = '<strong>⚠️ Configuration Error</strong><br>We encountered an issue with your mattress configuration. Our team has been notified and will reach out shortly.<br><small>Error: ' + errorType + '</small>';
  }
  
  function sendErrorNotification(error) {
    // Send to Klaviyo or webhook
    try {
      // Option 1: Send to a custom endpoint/webhook
      if (window.WRVBuilderConfig && window.WRVBuilderConfig.errorWebhook) {
        fetch(window.WRVBuilderConfig.errorWebhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(error)
        }).catch(function(e) { console.error('Failed to send error notification:', e); });
      }
      
      // Option 2: Track in Klaviyo if available
      if (window._learnq) {
        window._learnq.push(['track', 'Builder Error', error]);
      }
      
      // Option 3: Store in localStorage for later retrieval
      var storedErrors = JSON.parse(localStorage.getItem('wrvBuilderErrors') || '[]');
      storedErrors.push(error);
      // Keep only last 10 errors
      if (storedErrors.length > 10) storedErrors = storedErrors.slice(-10);
      localStorage.setItem('wrvBuilderErrors', JSON.stringify(storedErrors));
      
    } catch (e) {
      console.error('Error notification failed:', e);
    }
  }
  
  function clearErrors() {
    builderErrors = [];
    checkoutEnabled = true;
    var errorMsg = document.getElementById('builderErrorMsg');
    if (errorMsg) errorMsg.remove();
    var cartBtn = document.getElementById('btnCart');
    if (cartBtn) {
      cartBtn.disabled = false;
      cartBtn.style.opacity = '1';
      cartBtn.style.cursor = 'pointer';
    }
  }
  
  // ── GA4 Analytics Tracking ──
  var stepNames = { 1: 'mattress', 2: 'dimensions', 3: 'corners', 4: 'hinge', 5: 'review' };
  var stepEnterTime = Date.now();

  function track(event, params) {
    if (window.gtag) {
      gtag('event', event, params || {});
    }
  }

  // Track abandonment on page unload
  window.addEventListener('beforeunload', function() {
    if (S.step < 5 || !S._cartAdded) {
      track('builder_abandoned', {
        last_step: stepNames[S.step],
        last_step_number: S.step,
        max_step_reached: S.maxStep,
        mattress: S.matt,
        time_on_step_sec: Math.round((Date.now() - stepEnterTime) / 1000)
      });
    }
  });

  // State
  const S = {
    step: 1,
    maxStep: 1,
    matt: 'montana',
    comf: null,
    w: 60,
    l: 80,
    cornType: 'std',
    // Individual corner configs: style can be 'none', 'radius', 'angle', 'notch'
    corners: {
      tl: { style: 'none', w: 10, d: 10 },
      tr: { style: 'none', w: 10, d: 10 },
      bl: { style: 'none', w: 10, d: 10 },
      br: { style: 'none', w: 10, d: 10 }
    },
    editingCorner: null, // Currently editing corner
    hinge: 'none',
    hingePos: 40,
    thickType: 'same',
    addThick: 0, // Additional thickness (0-6")
    view: 'top'
  };
  
  // Legacy compatibility
  Object.defineProperty(S, 'corns', {
    get: function() {
      return {
        tl: S.corners.tl.style !== 'none',
        tr: S.corners.tr.style !== 'none',
        bl: S.corners.bl.style !== 'none',
        br: S.corners.br.style !== 'none'
      };
    }
  });
  
  // Config
  const TH = { montana: 10, aspen: 10, canyon: 8, dreambunk: 6 }; // Base thickness (Montana varies by comfort)
  const NM = { montana: 'Montana Hybrid', aspen: 'Aspen', canyon: 'Canyon', dreambunk: 'Dream Bunk' };
  const HANDLES = { montana: 'montana-hybrid-custom', aspen: 'aspen-custom', canyon: 'canyon-custom', dreambunk: 'dream-bunk-custom' };
  const CF = 49, HF = 99;
  
  // Get thickness based on mattress and comfort level
  function getThickness() {
    if (S.matt === 'montana') {
      // Soft is 11", Firm and Plush are 10"
      return S.comf === 'soft' ? 11 : 10;
    }
    return TH[S.matt] || 10;
  }
  
  const CORNER_NAMES = { tl: 'Top Left', tr: 'Top Right', bl: 'Bottom Left', br: 'Bottom Right' };
  
  // Size category from width
  function getSz(w) {
    // Size based on width first
    var sizeByWidth;
    if (w <= 38) sizeByWidth = 'twin';
    else if (w <= 54) sizeByWidth = 'full';
    else if (w <= 60) sizeByWidth = 'queen';
    else sizeByWidth = 'king'; // up to 76"
    
    // Adjust based on length
    // Twin/Full max length is 80", over that bumps up a size
    // Queen max length is 80", over that becomes King
    var l = S.l;
    
    if (sizeByWidth === 'twin' && l > 80) {
      sizeByWidth = 'full';
    }
    if (sizeByWidth === 'full' && l > 80) {
      sizeByWidth = 'queen';
    }
    if (sizeByWidth === 'queen' && l > 80) {
      sizeByWidth = 'king';
    }
    
    return sizeByWidth;
  }
  
  // Get variant title
  function getVariantTitle() {
    const size = getSz(S.w).charAt(0).toUpperCase() + getSz(S.w).slice(1);
    let corners;
    if (S.cornType === 'cust') {
      const n = Object.values(S.corns).filter(x => x).length;
      corners = n === 0 ? 'No Corner' : n === 1 ? '1 Corner' : n + ' Corners';
    } else {
      corners = 'No Corner';
    }
    const hinge = S.hinge !== 'none' ? 'Hinged' : 'No Hinge';
    return size + ' / ' + corners + ' / ' + hinge;
  }
  
  // Get variant ID from config
  function getVariantId() {
    const title = getVariantTitle();
    const variants = window.WRVBuilderConfig && window.WRVBuilderConfig.variants && window.WRVBuilderConfig.variants[S.matt] ? window.WRVBuilderConfig.variants[S.matt] : [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === title) return variants[i].id;
    }
    return null;
  }
  
  // Get variant data (price and compare_at_price)
  function getVariantData() {
    const title = getVariantTitle();
    const variants = window.WRVBuilderConfig && window.WRVBuilderConfig.variants && window.WRVBuilderConfig.variants[S.matt] ? window.WRVBuilderConfig.variants[S.matt] : [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === title) return variants[i];
    }
    return null;
  }
  
  // Get price from variants (for backward compatibility)
  function getPriceFromVariants() {
    var variant = getVariantData();
    return variant ? variant.price : null;
  }
  
  // Initialize
  // Handle mobile steps positioning
  function handleMobileSteps() {
    var steps = document.querySelector('.steps');
    var configMain = document.querySelector('.config-main');
    var builderMain = document.querySelector('.builder-main');
    
    if (!steps || !builderMain) return;
    
    function moveSteps() {
      var isMobile = window.innerWidth <= 900;
      
      if (isMobile && steps.parentElement !== builderMain) {
        // Move steps to the very end of builder-main on mobile
        builderMain.appendChild(steps);
        steps.classList.add('mobile-moved');
      } else if (!isMobile && steps.parentElement === builderMain) {
        // Move steps back into config-main on desktop
        if (configMain) {
          configMain.insertBefore(steps, configMain.firstChild);
          steps.classList.remove('mobile-moved');
        }
      }
    }
    
    // Run on load and resize
    moveSteps();
    window.addEventListener('resize', moveSteps);
  }
  
  function init() {
    handleMobileSteps();

    // Check URL params for pre-selected mattress (e.g. ?mattress=aspen or ?mattress=canyon&comfort=firm)
    try {
      var params = new URLSearchParams(window.location.search);
      var mattParam = params.get('mattress');
      if (mattParam) {
        var card = document.querySelector('.matt-card[data-matt="' + mattParam.toLowerCase() + '"]');
        if (card) {
          selMatt(card);
          // Optional comfort pre-select (Montana only)
          var comfParam = params.get('comfort');
          if (comfParam && mattParam.toLowerCase() === 'montana') {
            var comfBtn = document.querySelector('.comf-btn-sm[data-comf="' + comfParam.toLowerCase() + '"]');
            if (comfBtn) selComf(comfBtn);
          }
        }
      }
    } catch (e) { /* URLSearchParams not supported or other error — ignore */ }

    updPrev();
    updPrice();
    updUI();
    
    // GA4: Track builder page view (wait for gtag to load)
    (function waitForGtag(attempts) {
      if (window.gtag) {
        track('builder_viewed', {
          referrer: document.referrer,
          has_url_params: window.location.search.length > 1
        });
      } else if (attempts < 20) {
        setTimeout(function() { waitForGtag(attempts + 1); }, 250);
      }
    })(0);
  }
  
  // View toggle
  function setView(v) {
    S.view = v;
    var tabs = document.querySelectorAll('.prev-tab');
    for (var i = 0; i < tabs.length; i++) tabs[i].classList.remove('act');
    event.target.closest('.prev-tab').classList.add('act');
    var views = document.querySelectorAll('.prev-view');
    for (var i = 0; i < views.length; i++) views[i].classList.remove('act');
    document.getElementById(v === 'top' ? 'topView' : 'sideView').classList.add('act');
  }
  
  // Navigation
  function goTo(n) {
    // Allow going back to any previous step
    if (n < S.step) {
      S.step = n;
      updUI();
      return;
    }
    
    // Can't skip ahead more than one step
    if (n > S.maxStep + 1) return;
    
    // If trying to go forward, validate current step first
    if (n > S.step) {
      // Validate each step in sequence up to the target
      for (var checkStep = S.step; checkStep < n; checkStep++) {
        if (!validateStep(checkStep)) {
          return; // Stop if validation fails
        }
      }
    }
    
    S.step = n;
    if (n > S.maxStep) S.maxStep = n;
    updUI();
  }
  
  function validateStep(stepNum) {
    // Validate step 1: Montana requires comfort selection
    if (stepNum === 1 && S.matt === 'montana' && !S.comf) {
      var comfRow = document.getElementById('montanaComfort');
      if (comfRow) {
        comfRow.classList.add('comf-error');
        comfRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
    
    // Validate step 2: Dimensions must be valid
    if (stepNum === 2) {
      var wInput = document.getElementById('inpW');
      var lInput = document.getElementById('inpL');
      var wBox = document.getElementById('dimBoxW');
      var lBox = document.getElementById('dimBoxL');
      var rawW = parseInt(wInput.value) || 0;
      var rawL = parseInt(lInput.value) || 0;
      var wError = rawW < 20 || rawW > 80;
      var lError = rawL < 50 || rawL > 84;
      
      if (wError) {
        wBox.classList.add('dim-error');
        wBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (lError) {
        lBox.classList.add('dim-error');
        lBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }
    
    return true;
  }
  
  function next() {
    // Use shared validation
    if (!validateStep(S.step)) {
      // GA4: Track validation failures
      track('validation_failed', { step_name: stepNames[S.step], step_number: S.step });
      return;
    }
    
    if (S.step < 5) {
      // GA4: Track step completion with time spent
      track('step_completed', {
        step_name: stepNames[S.step],
        step_number: S.step,
        time_on_step_sec: Math.round((Date.now() - stepEnterTime) / 1000),
        mattress: S.matt
      });
      stepEnterTime = Date.now();
      
      S.step++;
      if (S.step > S.maxStep) S.maxStep = S.step;
      updUI();
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  
  function prev() {
    if (S.step > 1) {
      // GA4: Track going back (indicates hesitation/reconsideration)
      track('step_back', {
        from_step: stepNames[S.step],
        from_step_number: S.step,
        time_on_step_sec: Math.round((Date.now() - stepEnterTime) / 1000)
      });
      stepEnterTime = Date.now();
      
      S.step--;
      updUI();
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  
  function updUI() {
    var steps = document.querySelectorAll('.step');
    for (var i = 0; i < steps.length; i++) {
      var n = i + 1;
      steps[i].classList.remove('act', 'done', 'dis');
      if (n === S.step) steps[i].classList.add('act');
      else if (n < S.step) steps[i].classList.add('done');
      else if (n > S.maxStep + 1) steps[i].classList.add('dis');
    }
    var secs = document.querySelectorAll('.step-sec');
    for (var i = 0; i < secs.length; i++) {
      var stepNum = parseInt(secs[i].getAttribute('data-step'));
      if (stepNum === S.step) secs[i].classList.add('act');
      else secs[i].classList.remove('act');
    }
    document.getElementById('btnBack').style.display = S.step > 1 ? 'flex' : 'none';
    document.getElementById('btnNext').style.display = S.step < 5 ? 'flex' : 'none';
    document.getElementById('btnCart').style.display = S.step === 5 ? 'flex' : 'none';
    document.getElementById('btnSave').style.display = S.step === 5 ? 'flex' : 'none';
    if (S.step === 5) updSum();
    document.querySelector('.step-cont').scrollTop = 0;
    
    // Toggle step-5 class on wrapper for mobile header hiding
    var wrapper = document.querySelector('.builder-v2-wrapper');
    if (wrapper) {
      if (S.step === 5) wrapper.classList.add('on-review');
      else wrapper.classList.remove('on-review');
    }
  }
  
  // Mattress selection
  function selMatt(el) {
    var cards = document.querySelectorAll('.matt-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('sel');
    el.classList.add('sel');
    S.matt = el.getAttribute('data-matt');
    S.addThick = 0; // Reset additional thickness when changing mattress
    
    // GA4: Track mattress selection
    track('mattress_selected', { mattress: S.matt });
    
    // Update hinge constraints when changing mattress (Montana has 12" edge requirement)
    if (S.hinge !== 'none') {
      var edgeMin = getHingeEdgeMin();
      var slider = document.getElementById('hingeSlider');
      slider.min = edgeMin;
      if (S.hinge === 'vert') {
        slider.max = S.w - edgeMin;
        if (S.hingePos < edgeMin || S.hingePos > S.w - edgeMin) {
          S.hingePos = Math.round(S.w / 2);
          slider.value = S.hingePos;
          document.getElementById('hingePosVal').textContent = S.hingePos;
        }
      } else {
        slider.max = S.l - edgeMin;
        if (S.hingePos < edgeMin || S.hingePos > S.l - edgeMin) {
          S.hingePos = Math.round(S.l / 2);
          slider.value = S.hingePos;
          document.getElementById('hingePosVal').textContent = S.hingePos;
        }
      }
    }
    
    // Update detail panel with selected mattress info
    var detailImg = document.getElementById('detailImg');
    var detailName = document.getElementById('detailName');
    var detailDesc = document.getElementById('detailDesc');
    var detailTags = document.getElementById('detailTags');
    var detailBadge = document.getElementById('detailBadge');
    
    if (detailImg) detailImg.src = el.getAttribute('data-img');
    if (detailName) detailName.textContent = el.getAttribute('data-name');
    if (detailDesc) detailDesc.textContent = el.getAttribute('data-desc');
    if (detailBadge) {
      var badge = el.getAttribute('data-badge');
      detailBadge.textContent = badge || '';
      detailBadge.style.display = badge ? 'inline-block' : 'none';
    }
    
    // Update tags
    if (detailTags) {
      try {
        var tags = JSON.parse(el.getAttribute('data-tags') || '[]');
        // Filter out thickness tags (anything with " or Thick)
        tags = tags.filter(function(t) { return t.indexOf('"') === -1 && t.indexOf('Thick') === -1; });
        var tagsHtml = tags.map(function(t) { return '<span class="matt-tag">' + t + '</span>'; }).join('');
        tagsHtml += '<button type="button" class="matt-read-more" onclick="WRVBuilder.showProductLanding()">Learn More</button>';
        detailTags.innerHTML = tagsHtml;
      } catch(e) {
        detailTags.innerHTML = '<button type="button" class="matt-read-more" onclick="WRVBuilder.showProductLanding()">Learn More</button>';
      }
    }
    
    // Update reviews badge
    var detailReviews = document.getElementById('detailReviews');
    if (detailReviews) {
      var productHandle = el.getAttribute('data-product-handle');
      var productName = el.getAttribute('data-name');
      if (productHandle && window.WRVBuilderConfig && window.WRVBuilderConfig.productIds) {
        var productId = window.WRVBuilderConfig.productIds[productHandle];
        if (productId) {
          detailReviews.innerHTML = '<span class="stamped-product-reviews-badge stamped-main-badge" data-id="' + productId + '" data-product-sku="' + productHandle + '" data-product-title="' + productName + '" style="display:inline-block;"></span>';
          // Re-initialize Stamped badges - try multiple methods
          setTimeout(function() {
            if (typeof StampedFn !== 'undefined') {
              if (StampedFn.loadBadges) StampedFn.loadBadges();
              if (StampedFn.reloadUGC) StampedFn.reloadUGC();
              if (StampedFn.init) StampedFn.init();
            }
          }, 50);
        }
      }
    }
    
    // Reset comfort selection when switching to Montana (require new selection)
    if (el.getAttribute('data-comfort') === 'true') {
      // Clear any previous comfort selection
      var comfBtns = document.querySelectorAll('.comf-btn-sm');
      for (var i = 0; i < comfBtns.length; i++) comfBtns[i].classList.remove('sel');
      S.comf = null;
    } else {
      // Non-Montana mattresses don't need comfort selection
      S.comf = 'default';
    }
    
    document.getElementById('mainThickHint').textContent = getThickness();
    updPrev();
    updPrice();
  }
  
  function selComf(el) {
    var btns = document.querySelectorAll('.comf-btn-sm');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('sel');
    el.classList.add('sel');
    S.comf = el.getAttribute('data-comf');
    
    // GA4: Track comfort selection
    track('comfort_selected', { comfort: S.comf });
    
    // Remove error highlight when comfort is selected
    var comfRow = document.getElementById('montanaComfort');
    if (comfRow) {
      comfRow.classList.remove('comf-error');
    }
    
    // Update Montana thickness display based on comfort level
    var montanaThick = document.getElementById('montanaThick');
    if (montanaThick) {
      montanaThick.textContent = getThickness() + '"';
    }
    
    // Update build summary thickness
    var sumThick = document.getElementById('sumThickness');
    if (sumThick) sumThick.textContent = getThickness() + '"';
    
    // Update thickness hints if visible
    updateThickHints();
    
    updPrev();
    updPrice();
  }
  
  // Dimensions
  function updDim() {
    var wInput = document.getElementById('inpW');
    var lInput = document.getElementById('inpL');
    var wBox = document.getElementById('dimBoxW');
    var lBox = document.getElementById('dimBoxL');
    
    var rawW = parseInt(wInput.value) || 0;
    var rawL = parseInt(lInput.value) || 0;
    
    // Check for out-of-range values
    var wError = rawW < 20 || rawW > 80;
    var lError = rawL < 50 || rawL > 84;
    
    // Show/hide width error
    if (wError && rawW > 0) {
      wBox.classList.add('dim-error');
      wBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      wBox.classList.remove('dim-error');
    }
    
    // Show/hide length error
    if (lError && rawL > 0) {
      lBox.classList.add('dim-error');
      if (!wError) lBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      lBox.classList.remove('dim-error');
    }
    
    // Clamp values for internal state
    S.w = Math.min(80, Math.max(20, rawW || 60));
    S.l = Math.min(84, Math.max(50, rawL || 80));
    
    // Update hinge slider constraints (10" from edge, 12" for Montana)
    var edgeMin = getHingeEdgeMin();
    var slider = document.getElementById('hingeSlider');
    slider.min = edgeMin;
    if (S.hinge === 'vert') {
      slider.max = S.w - edgeMin;
    } else {
      slider.max = S.l - edgeMin;
    }
    
    // Clamp hinge position if out of bounds
    if (S.hingePos < edgeMin) {
      S.hingePos = edgeMin;
      slider.value = edgeMin;
      document.getElementById('hingePosVal').textContent = edgeMin;
    } else if (S.hinge === 'vert' && S.hingePos > S.w - edgeMin) {
      S.hingePos = S.w - edgeMin;
      slider.value = S.hingePos;
      document.getElementById('hingePosVal').textContent = S.hingePos;
    } else if (S.hinge === 'horiz' && S.hingePos > S.l - edgeMin) {
      S.hingePos = S.l - edgeMin;
      slider.value = S.hingePos;
      document.getElementById('hingePosVal').textContent = S.hingePos;
    }
    
    // Clamp corner dimensions if they exceed new mattress size
    for (var corner in S.corners) {
      var maxW = getCornerMaxW(corner);
      var maxD = getCornerMaxD(corner);
      if (S.corners[corner].w > maxW) {
        S.corners[corner].w = maxW;
        var wInp = document.getElementById('cornW_' + corner);
        if (wInp) wInp.value = maxW;
      }
      if (S.corners[corner].d > maxD) {
        S.corners[corner].d = maxD;
        var dInp = document.getElementById('cornD_' + corner);
        if (dInp) dInp.value = maxD;
      }
    }
    
    updPrev();
    updPrice();
  }
  
  function adjDim(dim, delta) {
    var input = document.getElementById(dim === 'w' ? 'inpW' : 'inpL');
    var min = dim === 'w' ? 20 : 50;
    var max = dim === 'w' ? 80 : 84;
    var val = parseInt(input.value) || (dim === 'w' ? 60 : 80);
    val = Math.max(min, Math.min(max, val + delta));
    input.value = val;
    updDim();
  }
  
  function setSize(w, l) {
    document.getElementById('inpW').value = w;
    document.getElementById('inpL').value = l;
    updDim();
  }
  
  // Corners
  function setCornType(t) {
    S.cornType = t;
    
    // GA4: Track corner type selection
    track('corner_type_selected', { corner_type: t });
    var btns = document.querySelectorAll('.corn-tog-btn');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('act');
    event.target.closest('.corn-tog-btn').classList.add('act');
    document.getElementById('stdSec').style.display = t === 'std' ? 'block' : 'none';
    if (t === 'cust') document.getElementById('custSec').classList.add('act');
    else document.getElementById('custSec').classList.remove('act');
    updPrev();
    updPrice();
  }
  
  function setCornStyleFor(corner, el) {
    var style = el.getAttribute('data-style');
    S.corners[corner].style = style;
    
    // GA4: Track individual corner configuration
    track('corner_configured', { corner: corner, style: style });
    
    // Update button styling within this corner's editor
    var editor = el.closest('.corn-editor');
    var btns = editor.querySelectorAll('.corn-style-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.remove('sel');
    }
    el.classList.add('sel');
    
    // Show/hide dimensions
    var dims = document.getElementById('cornDims_' + corner);
    if (style !== 'none') {
      dims.classList.add('show');
      editor.classList.add('active');
    } else {
      dims.classList.remove('show');
      editor.classList.remove('active');
    }
    
    updPrev();
    updPrice();
  }
  
  function updCornDimFor(corner) {
    S.corners[corner].w = parseInt(document.getElementById('cornW_' + corner).value) || 6;
    S.corners[corner].d = parseInt(document.getElementById('cornD_' + corner).value) || 6;
    updPrev();
  }
  
  function getCornerMaxW(corner) {
    // Width is horizontal - left corners share with right corners
    var maxW = S.w;
    if (corner === 'tl' || corner === 'bl') {
      // Left corners - check right corners on same row
      var rightCorner = corner === 'tl' ? 'tr' : 'br';
      if (S.corners[rightCorner].style !== 'none') {
        maxW = S.w - S.corners[rightCorner].w;
      }
    } else {
      // Right corners - check left corners on same row
      var leftCorner = corner === 'tr' ? 'tl' : 'bl';
      if (S.corners[leftCorner].style !== 'none') {
        maxW = S.w - S.corners[leftCorner].w;
      }
    }
    return Math.max(0, maxW);
  }
  
  function getCornerMaxD(corner) {
    // Depth is vertical - top corners share with bottom corners
    var maxD = S.l;
    if (corner === 'tl' || corner === 'tr') {
      // Top corners - check bottom corners on same side
      var bottomCorner = corner === 'tl' ? 'bl' : 'br';
      if (S.corners[bottomCorner].style !== 'none') {
        maxD = S.l - S.corners[bottomCorner].d;
      }
    } else {
      // Bottom corners - check top corners on same side
      var topCorner = corner === 'bl' ? 'tl' : 'tr';
      if (S.corners[topCorner].style !== 'none') {
        maxD = S.l - S.corners[topCorner].d;
      }
    }
    return Math.max(0, maxD);
  }
  
  function adjCornDim(corner, dim, delta) {
    var input = document.getElementById('corn' + dim.toUpperCase() + '_' + corner);
    var val = parseInt(input.value) || 0;
    
    // Get max based on mattress size and adjacent corners
    var max = dim === 'w' ? getCornerMaxW(corner) : getCornerMaxD(corner);
    
    val = Math.max(0, Math.min(max, val + delta));
    input.value = val;
    S.corners[corner][dim] = val;
    updPrev();
  }
  
  // Legacy functions for compatibility
  function togCornEdit(corner) {
    // No longer needed with new UI
  }
  
  function closeCornEdit() {
    // No longer needed with new UI
  }
  
  // Hinge
  function selHinge(el) {
    // Handle clicks on child elements
    var btn = el.closest ? el.closest('.hinge-btn') : el;
    if (!btn) btn = el;
    
    var btns = document.querySelectorAll('.hinge-btn');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('sel');
    btn.classList.add('sel');
    S.hinge = btn.getAttribute('data-hinge');
    
    // GA4: Track hinge selection
    track('hinge_configured', { hinge_type: S.hinge });
    
    var sec = document.getElementById('hingeSec');
    var slider = document.getElementById('hingeSlider');
    var lbl = document.getElementById('hingePosLbl');
    var sideLabel = document.getElementById('sideLabel');
    
    // Reset thickness to same when changing hinge type
    S.thickType = 'same';
    S.addThick = 0;
    var thickBtns = document.querySelectorAll('.thick-btn');
    for (var i = 0; i < thickBtns.length; i++) {
      thickBtns[i].classList.remove('sel');
      if (thickBtns[i].getAttribute('data-thick') === 'same') {
        thickBtns[i].classList.add('sel');
      }
    }
    var thickAmt = document.getElementById('thickAmt');
    var thickOpts = document.querySelector('.thick-opts');
    if (thickAmt) thickAmt.classList.remove('act');
    if (thickOpts) thickOpts.classList.remove('show-input');
    
    // Hinge must be at least 10" from edge (12" for Montana)
    var edgeMin = getHingeEdgeMin();
    if (S.hinge === 'horiz') {
      sec.classList.add('act');
      lbl.textContent = 'Hinge Position from Foot';
      slider.min = edgeMin;
      slider.max = S.l - edgeMin;
      // Reset position if out of bounds
      if (S.hingePos < edgeMin || S.hingePos > S.l - edgeMin) {
        S.hingePos = Math.round(S.l / 2);
        slider.value = S.hingePos;
        document.getElementById('hingePosVal').textContent = S.hingePos;
      }
      if (sideLabel) sideLabel.textContent = 'SIDE PROFILE';
    } else if (S.hinge === 'vert') {
      sec.classList.add('act');
      lbl.textContent = 'Hinge Position from Left';
      slider.min = edgeMin;
      slider.max = S.w - edgeMin;
      // Reset position if out of bounds
      if (S.hingePos < edgeMin || S.hingePos > S.w - edgeMin) {
        S.hingePos = Math.round(S.w / 2);
        slider.value = S.hingePos;
        document.getElementById('hingePosVal').textContent = S.hingePos;
      }
      if (sideLabel) sideLabel.textContent = 'VIEW FROM FOOT';
    } else {
      sec.classList.remove('act');
      if (sideLabel) sideLabel.textContent = 'SIDE PROFILE';
    }
    
    var sumThickRow = document.getElementById('sumThickRow');
    if (sumThickRow) sumThickRow.style.display = S.hinge !== 'none' ? 'flex' : 'none';
    
    updPrev();
    updPrice();
  }
  
  function updHingePos() {
    S.hingePos = parseInt(document.getElementById('hingeSlider').value);
    document.getElementById('hingePosVal').textContent = S.hingePos;
    updPrev();
  }
  
  function selThick(el) {
    var btns = document.querySelectorAll('.thick-btn');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('sel');
    el.classList.add('sel');
    S.thickType = el.getAttribute('data-thick');
    var amt = document.getElementById('thickAmt');
    var opts = document.querySelector('.thick-opts');
    var inp = document.getElementById('inpThick');
    var mt = getThickness();
    
    if (S.thickType === 'same') {
      amt.classList.remove('act');
      opts.classList.remove('show-input');
      S.addThick = 0;
    } else {
      amt.classList.add('act');
      opts.classList.add('show-input');
      if (S.addThick === 0) S.addThick = 1;
      inp.value = S.addThick;
      updateThickHints();
    }
    updPrev();
  }
  
  function updThick() {
    S.addThick = parseInt(document.getElementById('inpThick').value) || 0;
    updateThickHints();
    updPrev();
  }
  
  function adjThick(delta) {
    var input = document.getElementById('inpThick');
    var val = parseInt(input.value) || 0;
    val = Math.max(0, Math.min(6, val + delta));
    input.value = val;
    updThick();
  }
  
  function updateThickHints() {
    var mt = getThickness();
    var mainHint = document.getElementById('mainThickHint');
    var addHint = document.getElementById('addThickHint');
    var totalHint = document.getElementById('totalThickHint');
    if (mainHint) mainHint.textContent = mt;
    if (addHint) addHint.textContent = S.addThick;
    if (totalHint) totalHint.textContent = mt + S.addThick;
  }
  
  // Get hinge edge constraint based on mattress type
  function getHingeEdgeMin() {
    return S.matt === 'montana' ? 12 : 10;
  }
  
  // Preview
  function updPrev() {
    var cwEl = document.getElementById('inpCW');
    var cdEl = document.getElementById('inpCD');
    S.cw = cwEl ? (parseInt(cwEl.value) || 6) : 6;
    S.cd = cdEl ? (parseInt(cdEl.value) || 6) : 6;
    updTop();
    updSide();
    document.getElementById('lblW').textContent = S.w + '"';
    document.getElementById('lblL').textContent = S.l + '"';
    
    // Update build summary
    var sumMatt = document.getElementById('sumMattress');
    var sumThick = document.getElementById('sumThickness');
    var sumWidth = document.getElementById('sumWidth');
    var sumLength = document.getElementById('sumLength');
    var sumCorners = document.getElementById('sumCorners');
    var sumHinge = document.getElementById('sumHinge');
    
    if (sumMatt) sumMatt.textContent = NM[S.matt] + '™';
    if (sumThick) sumThick.textContent = getThickness() + '"';
    if (sumWidth) sumWidth.textContent = S.w + '"';
    if (sumLength) sumLength.textContent = S.l + '"';
    if (sumCorners) {
      if (S.cornType === 'std') {
        sumCorners.textContent = 'Standard';
      } else {
        var n = 0;
        for (var k in S.corners) if (S.corners[k].style !== 'none') n++;
        sumCorners.textContent = n === 0 ? 'Standard' : n + ' Custom';
      }
    }
    if (sumHinge) {
      var hingeText = 'None';
      if (S.hinge === 'horiz') hingeText = 'Horizontal';
      else if (S.hinge === 'vert') hingeText = 'Vertical';
      sumHinge.textContent = hingeText;
      
      // Also update footer summary
      var sumHingeFooter = document.getElementById('sumHingeFooter');
      if (sumHingeFooter) sumHingeFooter.textContent = hingeText;
    }
    
    // Position dimension labels dynamically based on mattress size
    var lblL = document.getElementById('lblL');
    var lblW = document.getElementById('lblW');
    var topCont = document.querySelector('.top-cont');
    var svgEl = document.getElementById('svgTop');
    
    if (lblL && lblW && topCont && svgEl) {
      // Calculate mattress position in the SVG coordinate system
      var mW = 320, mH = 260;
      var sc = Math.min(mW / S.w, mH / S.l);
      var w = S.w * sc;
      var l = S.l * sc;
      var oX = (400 - w) / 2;
      var oY = (320 - l) / 2;
      
      // Get actual SVG dimensions (excludes container padding)
      var svgRect = svgEl.getBoundingClientRect();
      var svgWidth = svgRect.width;
      var svgHeight = svgRect.height;
      var svgScaleX = svgWidth / 400;
      var svgScaleY = svgHeight / 320;
      
      // Get SVG position relative to container
      var contRect = topCont.getBoundingClientRect();
      var svgOffsetLeft = svgRect.left - contRect.left;
      var svgOffsetTop = svgRect.top - contRect.top;
      
      // Gap from mattress edge (in pixels)
      var gap = 8;
      
      // Length label (right side) - vertically centered on mattress
      var mattressRightEdge = svgOffsetLeft + (oX + w) * svgScaleX;
      var mattressCenterY = svgOffsetTop + (oY + l / 2) * svgScaleY;
      lblL.style.left = (mattressRightEdge + gap) + 'px';
      lblL.style.top = mattressCenterY + 'px';
      lblL.style.right = 'auto';
      
      // Width label (bottom) - horizontally centered on mattress
      var mattressBottomEdge = svgOffsetTop + (oY + l) * svgScaleY;
      var mattressCenterX = svgOffsetLeft + (oX + w / 2) * svgScaleX;
      lblW.style.top = (mattressBottomEdge + gap) + 'px';
      lblW.style.left = mattressCenterX + 'px';
      lblW.style.bottom = 'auto';
    }
  }
  
  function updTop() {
    var svg = document.getElementById('svgTop');
    var mW = 320, mH = 260;
    var sc = Math.min(mW / S.w, mH / S.l);
    var w = S.w * sc, l = S.l * sc;
    var oX = (400 - w) / 2, oY = (320 - l) / 2;
    
    var p = '';
    if (S.cornType === 'std') {
      var r = 5;
      p = 'M ' + (oX + r) + ' ' + oY + ' L ' + (oX + w - r) + ' ' + oY + ' Q ' + (oX + w) + ' ' + oY + ' ' + (oX + w) + ' ' + (oY + r) + ' L ' + (oX + w) + ' ' + (oY + l - r) + ' Q ' + (oX + w) + ' ' + (oY + l) + ' ' + (oX + w - r) + ' ' + (oY + l) + ' L ' + (oX + r) + ' ' + (oY + l) + ' Q ' + oX + ' ' + (oY + l) + ' ' + oX + ' ' + (oY + l - r) + ' L ' + oX + ' ' + (oY + r) + ' Q ' + oX + ' ' + oY + ' ' + (oX + r) + ' ' + oY + ' Z';
    } else {
      // Individual corner configs
      var tl = S.corners.tl, tr = S.corners.tr, bl = S.corners.bl, br = S.corners.br;
      var tlW = tl.w * sc, tlD = tl.d * sc;
      var trW = tr.w * sc, trD = tr.d * sc;
      var blW = bl.w * sc, blD = bl.d * sc;
      var brW = br.w * sc, brD = br.d * sc;
      
      // Start from top-left
      if (tl.style !== 'none') {
        p = 'M ' + (oX + tlW) + ' ' + oY;
      } else {
        p = 'M ' + oX + ' ' + oY;
      }
      
      // Top-right corner
      if (tr.style !== 'none') {
        if (tr.style === 'radius') p += ' L ' + (oX + w - trW) + ' ' + oY + ' Q ' + (oX + w) + ' ' + oY + ' ' + (oX + w) + ' ' + (oY + trD);
        else if (tr.style === 'angle') p += ' L ' + (oX + w - trW) + ' ' + oY + ' L ' + (oX + w) + ' ' + (oY + trD);
        else p += ' L ' + (oX + w - trW) + ' ' + oY + ' L ' + (oX + w - trW) + ' ' + (oY + trD) + ' L ' + (oX + w) + ' ' + (oY + trD);
      } else {
        p += ' L ' + (oX + w) + ' ' + oY;
      }
      
      // Bottom-right corner
      if (br.style !== 'none') {
        if (br.style === 'radius') p += ' L ' + (oX + w) + ' ' + (oY + l - brD) + ' Q ' + (oX + w) + ' ' + (oY + l) + ' ' + (oX + w - brW) + ' ' + (oY + l);
        else if (br.style === 'angle') p += ' L ' + (oX + w) + ' ' + (oY + l - brD) + ' L ' + (oX + w - brW) + ' ' + (oY + l);
        else p += ' L ' + (oX + w) + ' ' + (oY + l - brD) + ' L ' + (oX + w - brW) + ' ' + (oY + l - brD) + ' L ' + (oX + w - brW) + ' ' + (oY + l);
      } else {
        p += ' L ' + (oX + w) + ' ' + (oY + l);
      }
      
      // Bottom-left corner
      if (bl.style !== 'none') {
        if (bl.style === 'radius') p += ' L ' + (oX + blW) + ' ' + (oY + l) + ' Q ' + oX + ' ' + (oY + l) + ' ' + oX + ' ' + (oY + l - blD);
        else if (bl.style === 'angle') p += ' L ' + (oX + blW) + ' ' + (oY + l) + ' L ' + oX + ' ' + (oY + l - blD);
        else p += ' L ' + (oX + blW) + ' ' + (oY + l) + ' L ' + (oX + blW) + ' ' + (oY + l - blD) + ' L ' + oX + ' ' + (oY + l - blD);
      } else {
        p += ' L ' + oX + ' ' + (oY + l);
      }
      
      // Top-left corner (closing)
      if (tl.style !== 'none') {
        if (tl.style === 'radius') p += ' L ' + oX + ' ' + (oY + tlD) + ' Q ' + oX + ' ' + oY + ' ' + (oX + tlW) + ' ' + oY + ' Z';
        else if (tl.style === 'angle') p += ' L ' + oX + ' ' + (oY + tlD) + ' L ' + (oX + tlW) + ' ' + oY + ' Z';
        else p += ' L ' + oX + ' ' + (oY + tlD) + ' L ' + (oX + tlW) + ' ' + (oY + tlD) + ' L ' + (oX + tlW) + ' ' + oY + ' Z';
      } else {
        p += ' L ' + oX + ' ' + oY + ' Z';
      }
    }
    
    var hl = '';
    if (S.hinge === 'horiz') {
      var hy = oY + l - (S.hingePos * sc);
      hl = '<line x1="' + (oX + 5) + '" y1="' + hy + '" x2="' + (oX + w - 5) + '" y2="' + hy + '" stroke="#f3d661" stroke-width="3" stroke-dasharray="8,4"/>';
    } else if (S.hinge === 'vert') {
      var hx = oX + (S.hingePos * sc);
      hl = '<line x1="' + hx + '" y1="' + (oY + 5) + '" x2="' + hx + '" y2="' + (oY + l - 5) + '" stroke="#f3d661" stroke-width="3" stroke-dasharray="8,4"/>';
    }
    
    // Dimension lines
    var dimColor = '#1a4d3e';
    var dimOpacity = '0.4';
    var endLen = 8; // Length of end caps
    var dimGap = 15; // Gap from mattress edge
    
    // Width dimension line (bottom) - horizontal line with end caps
    var widthY = oY + l + dimGap;
    var widthLine = '<line x1="' + oX + '" y1="' + widthY + '" x2="' + (oX + w) + '" y2="' + widthY + '" stroke="' + dimColor + '" stroke-width="1.5" opacity="' + dimOpacity + '"/>';
    widthLine += '<line x1="' + oX + '" y1="' + (widthY - endLen/2) + '" x2="' + oX + '" y2="' + (widthY + endLen/2) + '" stroke="' + dimColor + '" stroke-width="1.5" opacity="' + dimOpacity + '"/>';
    widthLine += '<line x1="' + (oX + w) + '" y1="' + (widthY - endLen/2) + '" x2="' + (oX + w) + '" y2="' + (widthY + endLen/2) + '" stroke="' + dimColor + '" stroke-width="1.5" opacity="' + dimOpacity + '"/>';
    
    // Length dimension line (right) - vertical line with end caps
    var lengthX = oX + w + dimGap;
    var lengthLine = '<line x1="' + lengthX + '" y1="' + oY + '" x2="' + lengthX + '" y2="' + (oY + l) + '" stroke="' + dimColor + '" stroke-width="1.5" opacity="' + dimOpacity + '"/>';
    lengthLine += '<line x1="' + (lengthX - endLen/2) + '" y1="' + oY + '" x2="' + (lengthX + endLen/2) + '" y2="' + oY + '" stroke="' + dimColor + '" stroke-width="1.5" opacity="' + dimOpacity + '"/>';
    lengthLine += '<line x1="' + (lengthX - endLen/2) + '" y1="' + (oY + l) + '" x2="' + (lengthX + endLen/2) + '" y2="' + (oY + l) + '" stroke="' + dimColor + '" stroke-width="1.5" opacity="' + dimOpacity + '"/>';
    
    svg.innerHTML = '<defs><linearGradient id="gT" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#e8f0ed"/><stop offset="50%" stop-color="#dce8e2"/><stop offset="100%" stop-color="#c8d8d0"/></linearGradient><filter id="sT" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="6" stdDeviation="10" flood-color="#1a3d2e" flood-opacity="0.18"/></filter><pattern id="tP" patternUnits="userSpaceOnUse" width="50" height="50"><ellipse cx="25" cy="25" rx="20" ry="14" fill="none" stroke="#1a3d2e" stroke-width="0.4" opacity="0.06"/></pattern></defs><rect x="' + oX + '" y="' + oY + '" width="' + w + '" height="' + l + '" fill="url(#tP)" opacity="0.5" rx="3"/><path d="' + p + '" fill="url(#gT)" stroke="#2d5a47" stroke-width="2" filter="url(#sT)"/>' + hl + widthLine + lengthLine + '<text x="' + (oX + w / 2) + '" y="' + (oY + l / 2 - 6) + '" text-anchor="middle" fill="#1a4d3e" font-family="system-ui,sans-serif" font-size="16" font-weight="800" opacity="0.4">' + NM[S.matt] + '</text><text x="' + (oX + w / 2) + '" y="' + (oY + l / 2 + 12) + '" text-anchor="middle" fill="#1a4d3e" font-family="system-ui,sans-serif" font-size="13" font-weight="700" opacity="0.35">' + S.w + '" x ' + S.l + '"</text>';
  }
  
  function updSide() {
    var svg = document.getElementById('svgSide');
    var mt = getThickness();
    var ht = S.thickType === 'same' ? mt : mt + S.addThick; // Total hinged section thickness
    var mW = 420, sc = mW / S.l;
    var tW = S.l * sc, mH = mt * 4, hH = ht * 4;
    var oX = (500 - tW) / 2, bY = 130;
    
    var content = '';
    if (S.hinge === 'none') {
      content = '<rect x="' + oX + '" y="' + (bY - mH) + '" width="' + tW + '" height="' + mH + '" rx="6" fill="url(#gS)" stroke="#2d5a47" stroke-width="2" filter="url(#sS)"/><text x="' + (oX + tW / 2) + '" y="' + (bY - mH / 2 + 5) + '" text-anchor="middle" fill="#1a4d3e" font-family="system-ui,sans-serif" font-size="14" font-weight="800" opacity="0.4">' + mt + '" thick</text>';
    } else if (S.hinge === 'horiz') {
      var fW = S.hingePos * sc, hW = tW - fW, hX = oX + fW;
      var footFill = S.thickType !== 'same' ? '#d4e4dc' : 'url(#gS)';
      
      // Pivot point is always at TOP of main mattress height (not affected by foot thickness)
      var pivotX = hX - 3; // hinge point X (right edge of foot section)
      var pivotY = bY - mH; // hinge at TOP of mattress (same level as head section top)
      
      // Foot section - top is at same level as head, bottom extends down based on hH
      var footTopY = bY - mH; // Always aligned with head section top
      var footBottomY = footTopY + hH; // Extends down by foot thickness
      
      // Foot section corners (before rotation)
      var footTopLeft = { x: oX, y: footTopY };
      var footTopRight = { x: hX - 3, y: footTopY };
      var footBottomRight = { x: hX - 3, y: footBottomY };
      var footBottomLeft = { x: oX, y: footBottomY };
      
      // Tilt angle for visualization
      var tiltAngle = 25;
      var rad = tiltAngle * Math.PI / 180;
      var cos = Math.cos(rad);
      var sin = Math.sin(rad);
      
      function rotatePoint(p) {
        var dx = p.x - pivotX;
        var dy = p.y - pivotY;
        return {
          x: pivotX + dx * cos - dy * sin,
          y: pivotY + dx * sin + dy * cos
        };
      }
      
      var rTL = rotatePoint(footTopLeft);
      var rTR = footTopRight; // Pivot point doesn't move
      var rBR = rotatePoint(footBottomRight);
      var rBL = rotatePoint(footBottomLeft);
      
      // Tilted foot section as polygon
      content = '<polygon points="' + rTL.x + ',' + rTL.y + ' ' + rTR.x + ',' + rTR.y + ' ' + rBR.x + ',' + rBR.y + ' ' + rBL.x + ',' + rBL.y + '" fill="' + footFill + '" stroke="#2d5a47" stroke-width="2" filter="url(#sS)"/>';
      
      // Head section (flat, on platform)
      content += '<rect x="' + (hX + 3) + '" y="' + (bY - mH) + '" width="' + (hW - 3) + '" height="' + mH + '" rx="5" fill="url(#gS)" stroke="#2d5a47" stroke-width="2" filter="url(#sS)"/>';
      
      // Hinge indicator at top pivot point
      content += '<circle cx="' + hX + '" cy="' + (bY - mH) + '" r="5" fill="#f3d661" stroke="#d4bc3d" stroke-width="1.5"/>';
      
      // Dimension labels - positioned next to the mattress
      var dimColor = '#1a4d3e';
      
      // Hinge position label - below the foot section, centered on foot width
      var hingeLabelX = oX + fW/2;
      var hingeLabelY = bY + 18;
      content += '<rect x="' + (hingeLabelX - 18) + '" y="' + (hingeLabelY - 10) + '" width="36" height="18" rx="4" fill="' + dimColor + '"/>';
      content += '<text x="' + hingeLabelX + '" y="' + (hingeLabelY + 2) + '" text-anchor="middle" fill="#fff" font-size="10" font-weight="700">' + S.hingePos + '"</text>';
      
      // Head thickness label - to the right of head section, vertically centered
      var headLabelX = oX + tW + 8;
      var headLabelY = bY - mH/2;
      content += '<rect x="' + headLabelX + '" y="' + (headLabelY - 9) + '" width="30" height="18" rx="4" fill="' + dimColor + '"/>';
      content += '<text x="' + (headLabelX + 15) + '" y="' + (headLabelY + 3) + '" text-anchor="middle" fill="#fff" font-size="10" font-weight="700">' + mt + '"</text>';
      
      // Foot thickness label - to the left of tilted foot section, along the tilted edge
      // Position it at the midpoint of the left edge of the tilted foot
      var footMidX = (rTL.x + rBL.x) / 2 - 25;
      var footMidY = (rTL.y + rBL.y) / 2;
      content += '<rect x="' + (footMidX - 15) + '" y="' + (footMidY - 9) + '" width="30" height="18" rx="4" fill="' + dimColor + '"/>';
      content += '<text x="' + footMidX + '" y="' + (footMidY + 3) + '" text-anchor="middle" fill="#fff" font-size="10" font-weight="700">' + ht + '"</text>';
      
    } else if (S.hinge === 'vert') {
      // Vertical hinge - view from foot, V-shape opening up
      var leftW = S.hingePos * sc; // Left section width (this gets thicker)
      var rightW = tW - leftW;     // Right section width
      var centerX = oX + leftW;    // Hinge point at center
      var leftFill = S.thickType !== 'same' ? '#d4e4dc' : 'url(#gS)';
      var hH = ht * 4; // Height of left (hinged) section
      
      // V-shape angle
      var vAngle = 20; // degrees each side tilts from vertical
      var rad = vAngle * Math.PI / 180;
      
      // Pivot point at top center (hinge at top surface)
      var pivotY = bY - mH;
      
      // Left section - tilts left (outward), pivots at top-right corner
      var leftTopRight = { x: centerX - 2, y: pivotY };
      var leftTopLeft = { x: centerX - 2 - leftW, y: pivotY };
      var leftBottomLeft = { x: centerX - 2 - leftW, y: pivotY + hH };
      var leftBottomRight = { x: centerX - 2, y: pivotY + hH };
      
      // Rotate left section around its top-right corner (positive angle tilts left side UP and out)
      var cosL = Math.cos(rad);
      var sinL = Math.sin(rad);
      function rotateLeft(p) {
        var dx = p.x - leftTopRight.x;
        var dy = p.y - leftTopRight.y;
        return {
          x: leftTopRight.x + dx * cosL - dy * sinL,
          y: leftTopRight.y + dx * sinL + dy * cosL
        };
      }
      var rLTL = rotateLeft(leftTopLeft);
      var rLBL = rotateLeft(leftBottomLeft);
      var rLBR = rotateLeft(leftBottomRight);
      
      // Right section - tilts right (outward), pivots at top-left corner
      var rightTopLeft = { x: centerX + 2, y: pivotY };
      var rightTopRight = { x: centerX + 2 + rightW, y: pivotY };
      var rightBottomRight = { x: centerX + 2 + rightW, y: pivotY + mH };
      var rightBottomLeft = { x: centerX + 2, y: pivotY + mH };
      
      // Rotate right section around its top-left corner (negative angle tilts right side UP and out)
      var cosR = Math.cos(-rad);
      var sinR = Math.sin(-rad);
      function rotateRight(p) {
        var dx = p.x - rightTopLeft.x;
        var dy = p.y - rightTopLeft.y;
        return {
          x: rightTopLeft.x + dx * cosR - dy * sinR,
          y: rightTopLeft.y + dx * sinR + dy * cosR
        };
      }
      var rRTR = rotateRight(rightTopRight);
      var rRBR = rotateRight(rightBottomRight);
      var rRBL = rotateRight(rightBottomLeft);
      
      // Draw left section (hinged, potentially thicker)
      content = '<polygon points="' + leftTopRight.x + ',' + leftTopRight.y + ' ' + rLTL.x + ',' + rLTL.y + ' ' + rLBL.x + ',' + rLBL.y + ' ' + rLBR.x + ',' + rLBR.y + '" fill="' + leftFill + '" stroke="#2d5a47" stroke-width="2" filter="url(#sS)"/>';
      
      // Draw right section (main thickness)
      content += '<polygon points="' + rightTopLeft.x + ',' + rightTopLeft.y + ' ' + rRTR.x + ',' + rRTR.y + ' ' + rRBR.x + ',' + rRBR.y + ' ' + rRBL.x + ',' + rRBL.y + '" fill="url(#gS)" stroke="#2d5a47" stroke-width="2" filter="url(#sS)"/>';
      
      // Hinge indicator at top center
      content += '<circle cx="' + centerX + '" cy="' + pivotY + '" r="5" fill="#f3d661" stroke="#d4bc3d" stroke-width="1.5"/>';
      
      // Dimension labels
      var dimColor = '#1a4d3e';
      
      // Hinge position label - below, showing distance from left
      var hingeLabelX = oX + leftW/2;
      var hingeLabelY = bY + 18;
      content += '<rect x="' + (hingeLabelX - 18) + '" y="' + (hingeLabelY - 10) + '" width="36" height="18" rx="4" fill="' + dimColor + '"/>';
      content += '<text x="' + hingeLabelX + '" y="' + (hingeLabelY + 2) + '" text-anchor="middle" fill="#fff" font-size="10" font-weight="700">' + S.hingePos + '"</text>';
      
      // Left thickness label (hinged section)
      var leftMidX = (leftTopRight.x + rLTL.x) / 2;
      var leftMidY = (leftTopRight.y + rLBL.y) / 2 - 15;
      content += '<rect x="' + (leftMidX - 18) + '" y="' + (leftMidY - 9) + '" width="30" height="18" rx="4" fill="' + dimColor + '"/>';
      content += '<text x="' + (leftMidX - 3) + '" y="' + (leftMidY + 3) + '" text-anchor="middle" fill="#fff" font-size="10" font-weight="700">' + ht + '"</text>';
      
      // Right thickness label (main section)
      var rightMidX = (rightTopLeft.x + rRTR.x) / 2;
      var rightMidY = (rightTopLeft.y + rRBR.y) / 2 - 15;
      content += '<rect x="' + (rightMidX - 12) + '" y="' + (rightMidY - 9) + '" width="30" height="18" rx="4" fill="' + dimColor + '"/>';
      content += '<text x="' + (rightMidX + 3) + '" y="' + (rightMidY + 3) + '" text-anchor="middle" fill="#fff" font-size="10" font-weight="700">' + mt + '"</text>';
    }
    
    // Platform line and labels (different for vertical hinge)
    if (S.hinge === 'vert') {
      content += '<line x1="' + (oX - 30) + '" y1="' + bY + '" x2="' + (oX + tW + 30) + '" y2="' + bY + '" stroke="#a3a3a3" stroke-width="2" stroke-dasharray="4,4"/>';
      content += '<text x="' + (oX + tW/2) + '" y="' + (bY + 20) + '" text-anchor="middle" fill="#737373" font-size="9">VIEW FROM FOOT</text>';
      content += '<text x="' + oX + '" y="' + (bY + 20) + '" fill="#737373" font-size="9">LEFT</text>';
      content += '<text x="' + (oX + tW) + '" y="' + (bY + 20) + '" text-anchor="end" fill="#737373" font-size="9">RIGHT</text>';
    } else {
      content += '<line x1="' + (oX - 15) + '" y1="' + bY + '" x2="' + (oX + tW + 15) + '" y2="' + bY + '" stroke="#a3a3a3" stroke-width="2" stroke-dasharray="4,4"/><text x="' + (oX + tW + 20) + '" y="' + (bY + 3) + '" fill="#a3a3a3" font-size="9">Platform</text><text x="' + oX + '" y="' + (bY + 20) + '" fill="#737373" font-size="9">FOOT</text><text x="' + (oX + tW) + '" y="' + (bY + 20) + '" text-anchor="end" fill="#737373" font-size="9">HEAD</text>';
    }
    
    svg.innerHTML = '<defs><linearGradient id="gS" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stop-color="#e8f0ed"/><stop offset="100%" stop-color="#c8d8d0"/></linearGradient><filter id="sS" x="-10%" y="-10%" width="120%" height="130%"><feDropShadow dx="0" dy="3" stdDeviation="5" flood-color="#1a3d2e" flood-opacity="0.12"/></filter></defs>' + content;
  }
  
  // Pricing
  var lastPrice = null;
  
  function updPrice() {
    var variant = getVariantData();
    var variantTitle = getVariantTitle();
    
    if (variant && variant.price) {
      // Clear any previous pricing errors
      clearErrors();
      
      var salePrice = variant.price;
      var comparePrice = variant.compare_at_price || salePrice;
      
      // Check if price changed
      var priceChanged = lastPrice !== null && lastPrice !== salePrice;
      lastPrice = salePrice;
      
      // Format prices
      var sp = salePrice.toFixed(2);
      var op = comparePrice.toFixed(2);
      
      document.getElementById('priceOrig').textContent = '$' + parseFloat(op).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      var priceCurEl = document.getElementById('priceCur');
      priceCurEl.textContent = '$' + parseFloat(sp).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      document.getElementById('cartPrice').textContent = '$' + parseFloat(sp).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      
      // Update summary price
      var sumPriceEl = document.getElementById('sumPrice');
      if (sumPriceEl) sumPriceEl.textContent = '$' + parseFloat(sp).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      
      // Pulse animation when price changes
      if (priceChanged) {
        priceCurEl.classList.remove('pulse');
        void priceCurEl.offsetWidth; // Trigger reflow to restart animation
        priceCurEl.classList.add('pulse');
        // Remove class after animation completes
        setTimeout(function() {
          priceCurEl.classList.remove('pulse');
        }, 400);
      }
      
      // Calculate and display discount percentage
      var discountEl = document.getElementById('discountPct');
      var saveEl = document.getElementById('priceSave');
      if (comparePrice > salePrice) {
        var discountPct = Math.round((1 - (salePrice / comparePrice)) * 100);
        if (discountEl) discountEl.textContent = discountPct;
        if (saveEl) saveEl.style.display = '';
      } else {
        // No discount - hide the badge
        if (saveEl) saveEl.style.display = 'none';
      }
    } else {
      // Log error - no variant match found
      logError('NO_VARIANT_MATCH', {
        mattress: S.matt,
        variantTitle: variantTitle,
        size: getSz(S.w),
        width: S.w,
        length: S.l,
        corners: S.cornType === 'cust' ? Object.values(S.corns).filter(function(x) { return x; }).length : 0,
        hinge: S.hinge
      });
      
      document.getElementById('priceOrig').textContent = 'Error';
      document.getElementById('priceCur').textContent = 'Error';
      document.getElementById('cartPrice').textContent = 'Error';
    }
  }
  
  // Summary
  function updSum() {
    var ct = S.matt === 'montana' ? ' (' + S.comf.charAt(0).toUpperCase() + S.comf.slice(1) + ')' : '';
    document.getElementById('sumMatt').textContent = NM[S.matt] + ct;
    document.getElementById('sumSize').textContent = S.w + '" × ' + S.l + '"';
    
    if (S.cornType === 'std') {
      document.getElementById('sumCorn').textContent = 'Standard';
    } else {
      var n = 0;
      for (var k in S.corners) if (S.corners[k].style !== 'none') n++;
      document.getElementById('sumCorn').textContent = n === 0 ? 'Standard' : n + ' Custom corner' + (n !== 1 ? 's' : '');
    }
    
    if (S.hinge === 'none') {
      document.getElementById('sumHinge').textContent = 'None';
    } else {
      var t = S.hinge === 'horiz' ? 'Horizontal' : 'Vertical';
      document.getElementById('sumHinge').textContent = t + ' at ' + S.hingePos + '"';
    }
    
    if (S.hinge !== 'none') {
      var mt = getThickness();
      if (S.thickType === 'same') {
        document.getElementById('sumThick').textContent = 'Same (' + mt + '")';
      } else {
        var totalThick = mt + S.addThick;
        document.getElementById('sumThick').textContent = totalThick + '" (+' + S.addThick + '" additional)';
      }
    }
  }
  
  // Add to Cart
  function addCart() {
    var btn = document.getElementById('btnCart');
    var orig = btn.innerHTML;
    
    // Check if checkout is enabled (no errors)
    if (!checkoutEnabled) {
      logError('CHECKOUT_BLOCKED', { reason: 'Attempted checkout while errors exist' });
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Error - Contact Us';
      return;
    }
    
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin 1s linear infinite"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10"/></svg> Adding...';
    
    var variantId = getVariantId();
    
    if (!variantId) {
      logError('NO_VARIANT_ID', { 
        variantTitle: getVariantTitle(),
        mattress: S.matt,
        width: S.w,
        length: S.l
      });
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Error';
      setTimeout(function() { btn.innerHTML = orig; }, 2500);
      return;
    }
    
    var properties = {
      'Width': S.w,
      'Length': S.l
    };
    
    if (S.matt === 'montana') {
      properties['Comfort Level'] = S.comf;
    }
    
    properties['Corners'] = S.cornType === 'std' ? 'squared' : 'custom';
    
    if (S.cornType === 'cust') {
      // Format: "C: Style, x: W, y: D" matching supplier expectations
      // Standard corners must send x: 0, y: 0 (supplier requirement)
      var styleLabels = { none: 'Standard', radius: 'Radius', angle: 'Angle', notch: 'Notch' };
      var keys = ['tl', 'tr', 'bl', 'br'];
      var labels = { tl: 'Top Left', tr: 'Top Right', bl: 'Bottom Left', br: 'Bottom Right' };
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        var c = S.corners[k];
        var cw = c.style === 'none' ? 0 : c.w;
        var cd = c.style === 'none' ? 0 : c.d;
        properties[labels[k]] = 'C: ' + styleLabels[c.style] + ', x: ' + cw + ', y: ' + cd;
      }
    }
    
    // Hinge properties — only included when a hinge is selected (matches old builder convention)
    if (S.hinge !== 'none') {
      properties['Hinged'] = S.hinge === 'horiz' ? 'Horizontal' : 'Vertical';
      properties['Hinge'] = S.hingePos;
      properties['Hinged Foot Thickness'] = S.thickType !== 'same' ? S.addThick : 0;
    }
    
    // Generate preview URL for supplier — encodes current build into a builder page link
    // ES can click this to see the full visual preview with corners, hinge, dimensions
    var previewConfig = {
      matt: S.matt, w: S.w, l: S.l,
      cornType: S.cornType, corners: S.corners,
      hinge: S.hinge, hingePos: S.hingePos,
      thickType: S.thickType, addThick: S.addThick
    };
    if (S.matt === 'montana') previewConfig.comf = S.comf;
    try {
      var json = JSON.stringify(previewConfig);
      var b64 = btoa(unescape(encodeURIComponent(json)))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      properties['Preview url'] = window.location.origin + '/pages/build-preview?build=' + b64;
    } catch(e) {
      console.error('Preview URL encode error', e);
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties
      })
    })
    .then(function(res) { 
      if (!res.ok) {
        throw new Error('Cart response not ok: ' + res.status);
      }
      return res.json(); 
    })
    .then(function(data) {
      if (data.status === 422 || data.description) {
        // Shopify returned an error
        throw new Error(data.description || 'Cart add failed');
      }
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> Added!';
      btn.style.background = '#16a34a';
      
      // GA4: Track successful add to cart with full config
      S._cartAdded = true;
      var cornerCount = 0;
      if (S.cornType === 'cust') {
        for (var k in S.corners) if (S.corners[k].style !== 'none') cornerCount++;
      }
      
      // Use event_callback to ensure GA4 sends before page redirect
      if (window.gtag) {
        gtag('event', 'add_to_cart', {
          mattress: S.matt,
          comfort: S.comf,
          width: S.w,
          length: S.l,
          corner_type: S.cornType,
          corner_count: cornerCount,
          hinge_type: S.hinge,
          hinge_position: S.hingePos,
          has_extra_thickness: S.thickType !== 'same',
          event_callback: function() {
            window.location.href = '/cart';
          }
        });
        // Safety timeout in case callback never fires
        setTimeout(function() {
          window.location.href = '/cart';
        }, 2000);
      } else {
        setTimeout(function() {
          window.location.href = '/cart';
        }, 1000);
      }
    })
    .catch(function(err) {
      logError('CART_ADD_FAILED', {
        error: err.message,
        variantId: variantId,
        variantTitle: getVariantTitle()
      });
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Error';
      setTimeout(function() { btn.innerHTML = orig; }, 2500);
    });
  }
  
  // Measure help modal functions
  function showMeasureHelp() {
    var modal = document.getElementById('measureModal');
    if (modal) modal.classList.add('active');
  }
  
  function closeMeasureHelp(event) {
    var modal = document.getElementById('measureModal');
    if (modal) modal.classList.remove('active');
  }
  
  // Corner help modal functions
  var cornerImages = {
    radius: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/measure-radius2.jpg?v=1769811431&width=600&format=webp',
    angle: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/measure-angle.jpg?v=1769810360&width=600&format=webp',
    notch: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/measure-notch.jpg?v=1769810358&width=600&format=webp'
  };
  
  function showCornerHelp() {
    var modal = document.getElementById('cornerHelpModal');
    var options = document.getElementById('cornerHelpOptions');
    var image = document.getElementById('cornerHelpImage');
    if (modal) {
      options.style.display = 'block';
      image.style.display = 'none';
      modal.classList.add('active');
    }
  }
  
  function closeCornerHelp(event) {
    var modal = document.getElementById('cornerHelpModal');
    if (modal) modal.classList.remove('active');
  }
  
  function showCornerImage(type) {
    var options = document.getElementById('cornerHelpOptions');
    var image = document.getElementById('cornerHelpImage');
    var img = document.getElementById('cornerHelpImg');
    if (options && image && img) {
      options.style.display = 'none';
      image.style.display = 'block';
      img.src = cornerImages[type];
    }
  }
  
  function backToCornerOptions() {
    var options = document.getElementById('cornerHelpOptions');
    var image = document.getElementById('cornerHelpImage');
    if (options && image) {
      options.style.display = 'block';
      image.style.display = 'none';
    }
  }
  
  // Hinge help modal functions
  var hingeImages = {
    horizontal: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/IMG_3455.jpg?v=1769798035&width=600&format=webp',
    vertical: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/IMG_3455.jpg?v=1769798035&width=600&format=webp',
    unlevel: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/IMG_3455.jpg?v=1769798035&width=600&format=webp'
  };
  
  function showHingeHelp() {
    var modal = document.getElementById('hingeHelpModal');
    var options = document.getElementById('hingeHelpOptions');
    var image = document.getElementById('hingeHelpImage');
    if (modal) {
      options.style.display = 'block';
      image.style.display = 'none';
      modal.classList.add('active');
    }
  }
  
  function closeHingeHelp(event) {
    var modal = document.getElementById('hingeHelpModal');
    if (modal) modal.classList.remove('active');
  }
  
  function showHingeImage(type) {
    var options = document.getElementById('hingeHelpOptions');
    var image = document.getElementById('hingeHelpImage');
    var img = document.getElementById('hingeHelpImg');
    if (options && image && img) {
      options.style.display = 'none';
      image.style.display = 'block';
      img.src = hingeImages[type];
    }
  }
  
  function backToHingeOptions() {
    var options = document.getElementById('hingeHelpOptions');
    var image = document.getElementById('hingeHelpImage');
    if (options && image) {
      options.style.display = 'block';
      image.style.display = 'none';
    }
  }
  
  // Product Landing Page Data - Premium Template
  var productLandingData = {
    montana: {
      name: 'Montana Hybrid™',
      shortName: 'Montana',
      badge: '#1 BEST SELLER -- 4,630+ Reviews',
      subtitle: 'Sleep Like You\'re Home, Wherever You Roam',
      description: 'Handcrafted with 961+ individually wrapped coils and premium cooling foam. The ultimate mattress for full-time RVers and weekend adventurers alike. Three comfort levels available--Firm, Plush, and Soft Pillowtop--so you can find your perfect feel. Ships compressed in a box for easy RV door entry.',
      images: [
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Main_1_MH.jpg?v=1732299051&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Main_1_MH.jpg?v=1732299051&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Main_2_MH.jpg?v=1732299051&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Main_2_MH.jpg?v=1732299051&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_1.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_1.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_2.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_2.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_3.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_3.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_4.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/23-23-01_4.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0412copy.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0412copy.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0407copy.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0407copy.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0408copy.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0408copy.jpg?v=1692889461&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0410copy.jpg?v=1692889461&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/products/Montana_Studio0410copy.jpg?v=1692889461&width=1500&format=webp' }
      ],
      stats: [
        { value: '961+', label: 'Wrapped Coils' },
        { value: '10-11"', label: 'Profile' },
        { value: '10 Yr', label: 'Warranty' }
      ],
      features: [
        { icon: 'temperature', title: 'Temperature Regulation', desc: 'Advanced cooling gel foam wicks heat away--stay comfortable from desert heat to mountain cold.' },
        { icon: 'motion', title: 'Motion Isolation', desc: '961 individually wrapped coils prevent motion transfer. Your partner won\'t wake you--even in a rocking RV.' },
        { icon: 'edge', title: 'Reinforced Edge Support', desc: 'High-caliber perimeter coils create firm edges so you can use the entire mattress without roll-off.' },
        { icon: 'box', title: 'Compact Box Shipping', desc: 'Ships in a 17" x 17" x 42" box. Fits through narrow RV doors easily. Ready to sleep on in 15 minutes.' }
      ],
      layers: [
        { depth: '1"', name: 'Quilted Pillow Top', desc: 'Soft knit cover with premium cushioning' },
        { depth: '1"', name: 'Hyper-Elastic Foam', desc: 'Immediate response technology' },
        { depth: '1"', name: 'Transitional Foam', desc: 'Pressure relief & contouring' },
        { depth: '6"', name: 'Wrapped Coils', desc: '961 coils with reinforced perimeter' },
        { depth: '1"', name: 'Base Support Foam', desc: 'High-density foundation' }
      ],
      layersTitle: 'Why Hybrid Beats Foam',
      layersDesc: 'Unlike memory foam mattresses that trap heat and create a "stuck" feeling, our hybrid construction combines responsive coils with premium foam. You get contouring comfort with the support and breathability of traditional springs.',
      specs: [
        { label: 'Total Height', value: '10-11"' },
        { label: 'Coil Count', value: '961+' },
        { label: 'Certification', value: 'CertiPUR-US' },
        { label: 'Made In', value: 'USA 🇺🇸' }
      ],
      testimonials: [
        { text: 'Best mattress we\'ve ever had in our RV. We\'re full-timers and this sleeps just like our old bed at home. The cooling really works too--no more waking up sweaty. Worth every penny!', author: 'Mike & Sarah T.', location: 'Full-time RVers, Texas' },
        { text: 'After 3 years of terrible sleep in our fifth wheel, we finally took the plunge. Should have done it sooner! The plush comfort level is perfect for us.', author: 'Jennifer K.', location: 'Fifth Wheel Owner, Colorado' },
        { text: 'The edge support is incredible. I can sit on the edge to put my shoes on without sliding off. Game changer for a smaller RV bedroom.', author: 'Robert M.', location: 'Class A Owner, Florida' },
        { text: 'My husband and I have different firmness preferences. The plush works perfectly for both of us. No more arguments about the mattress!', author: 'Lisa P.', location: 'Travel Trailer, Arizona' },
        { text: 'Shipped fast and was easy to get through our narrow RV door. Expanded quickly and we slept on it that same night. Amazing quality.', author: 'Tom & Nancy W.', location: 'Motorhome Owners, Oregon' },
        { text: 'We bought this for our RV and loved it so much we bought another one for our guest room at home. That says it all!', author: 'David R.', location: 'Weekend Camper, Nevada' },
        { text: 'The 100-night trial gave us confidence to try it. Two years later and it still feels brand new. Best investment for our RV.', author: 'Karen S.', location: 'Full-timer, New Mexico' },
        { text: 'Finally, a mattress that doesn\'t make me sweat in the summer. The cooling technology actually works. Highly recommend the firm version.', author: 'James H.', location: 'Class C Owner, California' },
        { text: 'We\'ve tried 3 different RV mattresses over the years. This is by far the best. The hybrid design gives great support without being too hard.', author: 'Patricia L.', location: 'Toy Hauler, Utah' },
        { text: 'Worth every penny! My back pain has improved significantly since switching to the Montana. Should have upgraded years ago.', author: 'Steve & Mary B.', location: 'Retired RVers, Montana' },
        { text: 'Our old RV mattress was causing us both back pain. After two weeks on the Montana, we\'re sleeping better than ever. The firm version is perfect for us.', author: 'George & Helen R.', location: 'Class A Owners, Ohio' },
        { text: 'I was skeptical about buying a mattress online, but the reviews convinced me. So glad I took the chance - this is restaurant quality sleep!', author: 'Michelle T.', location: 'Travel Trailer, Georgia' },
        { text: 'The customer service was amazing. They helped me pick the right size and firmness. Mattress arrived in 5 days and is incredible.', author: 'Frank D.', location: 'Fifth Wheel Owner, Pennsylvania' },
        { text: 'We\'re weekend warriors and this mattress makes our trips so much better. No more dreading the drive home because we\'re exhausted.', author: 'Amy & Chris L.', location: 'Toy Hauler, Michigan' },
        { text: 'Replaced the factory mattress in our new RV immediately. Night and day difference! Should be standard equipment in every RV.', author: 'Richard K.', location: 'Class C Owner, Virginia' }
      ]
    },
    aspen: {
      name: 'Aspen™',
      shortName: 'Aspen',
      badge: 'LUXURY MEMORY FOAM',
      subtitle: 'Premium Comfort, Zero Motion Transfer',
      description: 'A luxury 10" all-foam mattress with the perfect combination of firm and soft. Great for all sleep positions and those who prefer a spring-free sleep experience. Features 2.5" of gel-infused memory foam for pressure relief and temperature regulation. Zero motion transfer--ideal for couples.',
      images: [
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen12.jpg?v=1732301044&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen12.jpg?v=1732301044&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen11.jpg?v=1732301043&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen11.jpg?v=1732301043&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen9.jpg?v=1732301044&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen9.jpg?v=1732301044&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen10.jpg?v=1732301044&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen10.jpg?v=1732301044&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen8.jpg?v=1732301044&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen8.jpg?v=1732301044&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen7.jpg?v=1732301044&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen7.jpg?v=1732301044&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen6.jpg?v=1732301043&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen6.jpg?v=1732301043&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen5.jpg?v=1732301043&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen5.jpg?v=1732301043&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen13.jpg?v=1732301043&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen13.jpg?v=1732301043&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen4.jpg?v=1732301044&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Aspen4.jpg?v=1732301044&width=1500&format=webp' }
      ],
      stats: [
        { value: '10"', label: 'Profile' },
        { value: '5/10', label: 'Firmness' },
        { value: '10 Yr', label: 'Warranty' }
      ],
      features: [
        { icon: 'memory', title: 'Gel Memory Foam', desc: '2.5" of gel-infused memory foam delivers contouring support with added cooling and pressure relief.' },
        { icon: 'motion', title: 'Zero Motion Transfer', desc: 'All-foam construction means no partner disturbance--sleep through the night undisturbed.' },
        { icon: 'pressure', title: 'Pressure Relief', desc: 'Conforms to your body shape for personalized comfort without the feeling of sinking into the mattress.' },
        { icon: 'box', title: 'Compact Box Shipping', desc: 'Ships compressed in a 17" x 17" x 42" box. Ready to sleep on in 10-15 minutes.' }
      ],
      layers: [
        { depth: '1"', name: 'Quilted Top', desc: 'High-end knit weave cover' },
        { depth: '2.5"', name: 'Gel Memory Foam', desc: 'Contouring support with cooling' },
        { depth: '6.5"', name: 'Poly Foam Base', desc: 'High-density structural foundation' }
      ],
      layersTitle: 'Spring-Free Comfort',
      layersDesc: 'After years of testing, we created the perfect combination of firm and soft for a medium firmness mattress. The all-foam design eliminates motion transfer completely--ideal for couples.',
      specs: [
        { label: 'Total Height', value: '10"' },
        { label: 'Firmness', value: 'Medium (5/10)' },
        { label: 'Certification', value: 'CertiPUR-US' },
        { label: 'Made In', value: 'USA 🇺🇸' }
      ],
      testimonials: [
        { text: 'Finally, a mattress that doesn\'t wake me up when my husband moves. The pressure relief is incredible--my back pain has significantly improved since switching.', author: 'Linda M.', location: '5th Wheel Owner, Arizona' },
        { text: 'Perfect medium feel. Not too soft, not too firm. We both sleep like babies now. The all-foam design is so quiet too!', author: 'Chris & Amy D.', location: 'Travel Trailer, Washington' },
        { text: 'I was skeptical about memory foam but this exceeded my expectations. Stays cool and the support is fantastic.', author: 'Mark T.', location: 'Class B Owner, Michigan' },
        { text: 'Great for side sleepers! My shoulders and hips don\'t ache anymore. The contouring is just right.', author: 'Susan R.', location: 'Camper Van, Vermont' },
        { text: 'We downsized from a hybrid to all-foam and love it. Lighter weight and just as comfortable. Perfect for our smaller RV.', author: 'Bill & Jean K.', location: 'Popup Camper, Maine' },
        { text: 'The gel foam really does keep you cool. Even in Arizona summers, we sleep comfortably without AC running all night.', author: 'Rachel P.', location: 'Desert Camper, Arizona' },
        { text: 'Bought this for my daughter\'s bunk area. She says it\'s more comfortable than her bed at home!', author: 'Michelle L.', location: 'Family RVer, Texas' },
        { text: 'Zero motion transfer is real. My partner gets up early and I never notice. Life changing for light sleepers.', author: 'Frank S.', location: 'Retired Traveler, Florida' },
        { text: 'Third RV mattress we\'ve tried. Finally found the one. The Aspen hits the sweet spot for comfort and support.', author: 'Diane W.', location: 'Full-timer, California' },
        { text: 'Easy to move and flip. The quality is obvious as soon as you touch it. Very happy with this purchase.', author: 'Greg H.', location: 'Weekend Warrior, Ohio' },
        { text: 'My chiropractor recommended memory foam and the Aspen delivered. Wake up without the usual stiffness now.', author: 'Nancy B.', location: 'Class C Owner, Tennessee' },
        { text: 'The contouring support is amazing. Feels like it was custom made for my body. Best sleep I\'ve had in years.', author: 'Harold & Marge P.', location: 'Retired Couple, New Mexico' },
        { text: 'We upgraded from the factory mattress and it\'s like night and day. Should have done this years ago!', author: 'Kevin J.', location: 'Travel Trailer, Illinois' },
        { text: 'Perfect for our needs. Not as expensive as the hybrid but still incredibly comfortable. Great value.', author: 'Barbara T.', location: 'Fifth Wheel, Nevada' },
        { text: 'Compact shipping made it easy to get in our small RV door. Expanded perfectly and feels luxurious.', author: 'Dennis M.', location: 'Camper Van, Oregon' }
      ]
    },
    canyon: {
      name: 'Canyon™',
      shortName: 'Canyon',
      badge: 'BEST VALUE',
      subtitle: 'Comfort Meets Budget',
      description: 'Designed to be the perfect mix between comfort and budget. A firm/medium-firm mattress that\'s still tons better than your stock RV mattress, without costing a small fortune. Features 2" of gel memory foam on a high-density base. Perfect for weekend campers who want quality sleep without the premium price.',
      images: [
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon14.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon14.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon13.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon13.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon12.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon12.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon11.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon11.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon9.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon9.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon8.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon8.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon10.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon10.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon7.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon7.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon6.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon6.jpg?v=1732301777&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon4.jpg?v=1732301777&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/Canyon4.jpg?v=1732301777&width=1500&format=webp' }
      ],
      stats: [
        { value: '8"', label: 'Profile' },
        { value: '7/10', label: 'Firmness' },
        { value: '10 Yr', label: 'Warranty' }
      ],
      features: [
        { icon: 'firm', title: 'Firm Support', desc: 'Medium-firm comfort level works great for all sleep positions, especially back and stomach sleepers.' },
        { icon: 'value', title: 'Exceptional Value', desc: 'Premium materials at a budget-friendly price--perfect for weekend campers who don\'t want to break the bank.' },
        { icon: 'cooling', title: 'Gel Memory Foam', desc: '2" of gel memory foam provides pressure relief without sinking, plus added cooling benefits.' },
        { icon: 'box', title: 'Compact Box Shipping', desc: 'Ships compressed in a 17" x 17" x 42" box. Ready to sleep on in 10-15 minutes.' }
      ],
      layers: [
        { depth: '1"', name: 'Quilted Cover', desc: 'High-end knit weave top' },
        { depth: '2"', name: 'Gel Memory Foam', desc: 'Pressure relief with cooling' },
        { depth: '5"', name: 'Poly Foam Base', desc: 'High-density durable core' }
      ],
      layersTitle: 'Smart Design, Great Price',
      layersDesc: 'The Canyon was designed to be more budget-friendly for people who only get to camp a few weekends each year. An option that\'s still tons better than your stock RV mattress, without the premium price tag.',
      specs: [
        { label: 'Total Height', value: '8"' },
        { label: 'Firmness', value: 'Firm (7/10)' },
        { label: 'Certification', value: 'CertiPUR-US' },
        { label: 'Made In', value: 'USA 🇺🇸' }
      ],
      testimonials: [
        { text: 'Great firm mattress for the price. Exactly what we needed for our bunkhouse camper. My back has never felt better.', author: 'Tom H.', location: 'Toy Hauler Owner, Nevada' },
        { text: 'Best budget option out there. Way better than the stock mattress that came with our RV. Kids love their new bunks!', author: 'Amanda & Jeff R.', location: 'Family Campers, Idaho' },
        { text: 'Don\'t let the price fool you--this is a quality mattress. Firm support is exactly what I needed for my lower back.', author: 'Carl M.', location: 'Weekend Camper, Kansas' },
        { text: 'Perfect for our seasonal camping. We only use the RV a few times a year but wanted something comfortable. Great value!', author: 'Nancy L.', location: 'Seasonal Camper, Minnesota' },
        { text: 'Bought two for our bunk beds. Kids actually want to go camping now. No more complaints about uncomfortable beds.', author: 'Pete & Sara T.', location: 'Family of 5, Wisconsin' },
        { text: 'Excellent quality for a guest mattress in our RV. Friends and family always comment on how well they sleep.', author: 'Barbara K.', location: 'Entertainer, Tennessee' },
        { text: 'Firm but not hard. The gel foam layer makes a real difference. Pleasantly surprised at this price point.', author: 'Dennis R.', location: 'New RVer, Georgia' },
        { text: 'We camp maybe 10 weekends a year. This mattress is perfect--good quality without overspending. Smart purchase.', author: 'Laura & Mike S.', location: 'Occasional Campers, Virginia' },
        { text: 'Replaced our 15-year-old RV mattress with this. What a difference! Should have done it years ago.', author: 'Howard J.', location: 'Vintage RV Owner, Oklahoma' },
        { text: 'Solid construction and comfortable. You can feel the quality. Great option if you don\'t need the premium features.', author: 'Cindy B.', location: 'Budget Camper, Arkansas' },
        { text: 'Exactly what we needed for a guest bed. Affordable but still comfortable. Guests always sleep well on it.', author: 'Ruth & Ed K.', location: 'Hosts, Kentucky' },
        { text: 'Great starter mattress for new RVers. Comfortable enough for weekend trips without the premium price tag.', author: 'College Student Jake', location: 'Budget Traveler, Colorado' },
        { text: 'The firm support is excellent for back sleepers. Wake up refreshed without spending a fortune.', author: 'Martin P.', location: 'Solo Traveler, Nebraska' },
        { text: 'Ordered the custom size and it fit perfectly. Great value compared to other custom options out there.', author: 'Donna & Ray F.', location: 'Unique RV Owners, Missouri' },
        { text: 'No frills but solid quality. Does exactly what it needs to do. Recommended for budget-conscious campers.', author: 'Practical Paul', location: 'Value Shopper, Iowa' }
      ]
    },
    dreambunk: {
      name: 'Dream Bunk™',
      shortName: 'Dream Bunk',
      badge: 'PERFECT FOR BUNKS',
      subtitle: 'Lightweight Comfort for Tight Spaces',
      description: 'Designed with comfort in mind for bunk beds and tight spaces. Two inches of gel memory foam gently contours to your body for exceptional pressure point relief in a low-profile 6" design. Lightweight and easy to maneuver--perfect for upper bunks. Kids and guests will actually look forward to sleeping in the RV.',
      images: [
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk5.jpg?v=1732299727&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk5.jpg?v=1732299727&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk7.jpg?v=1732299726&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk7.jpg?v=1732299726&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk6.jpg?v=1732299727&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk6.jpg?v=1732299727&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk2.jpg?v=1732299726&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk2.jpg?v=1732299726&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk1.jpg?v=1732299726&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk1.jpg?v=1732299726&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk4.jpg?v=1732299726&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk4.jpg?v=1732299726&width=1500&format=webp' },
        { thumb: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk3.jpg?v=1732299726&width=180&format=webp', full: 'https://cdn.shopify.com/s/files/1/0055/2065/4383/files/DreamBunk3.jpg?v=1732299726&width=1500&format=webp' }
      ],
      stats: [
        { value: '6"', label: 'Profile' },
        { value: '8/10', label: 'Firmness' },
        { value: '10 Yr', label: 'Warranty' }
      ],
      features: [
        { icon: 'thin', title: 'Low Profile Design', desc: 'At just 6" thick, ideal for bunks with limited headroom and tight spaces.' },
        { icon: 'light', title: 'Lightweight', desc: 'Easy to lift and maneuver in tight RV spaces. Perfect for upper bunks.' },
        { icon: 'memory', title: 'Memory Foam Comfort', desc: '2" of hyper-elastic foam adjusts to your body each time you move--never feel stuck.' },
        { icon: 'box', title: 'Compact Box Shipping', desc: 'Ships compressed in a small box. Ready to sleep on in 10-15 minutes.' }
      ],
      layers: [
        { depth: '1"', name: 'Quilted Cover', desc: 'High-end knit weave top' },
        { depth: '2"', name: 'Memory Foam', desc: 'Hyper-elastic response technology' },
        { depth: '4"', name: 'High-Density Base', desc: 'Durable support foundation' }
      ],
      layersTitle: 'Built for Bunks',
      layersDesc: 'The Dream Bunk gel memory foam mattress reduces tossing and turning for a deeper, more restful night\'s sleep. A 4" high-density base foam provides greater durability and support.',
      specs: [
        { label: 'Total Height', value: '6"' },
        { label: 'Firmness', value: 'Med-Firm (8/10)' },
        { label: 'Certification', value: 'CertiPUR-US' },
        { label: 'Made In', value: 'USA 🇺🇸' }
      ],
      testimonials: [
        { text: 'Perfect for our kids\' bunks. They actually want to sleep in the RV now! Finally found a bunk mattress that fits AND is comfortable.', author: 'Amanda W.', location: 'Family of 5, Oregon' },
        { text: 'Low profile was exactly what we needed. Plenty of headroom now and the kids sleep great. Win-win!', author: 'Jason & Kelly M.', location: 'Bunkhouse Owners, Colorado' },
        { text: 'Lightweight enough that even our 10-year-old can make his own bed. And he actually does now!', author: 'Stacy R.', location: 'Mom of 3, Utah' },
        { text: 'Our grandkids love visiting now. These bunk mattresses are so much better than what came with the RV.', author: 'Grandma Sue', location: 'Traveling Grandparents, Florida' },
        { text: 'Great for the dinette conversion bed too. Folds nicely and comfortable enough for regular sleeping.', author: 'Brian T.', location: 'Solo Traveler, Nevada' },
        { text: 'Bought 4 of these for our bunkhouse. All the kids sleep soundly now. No more middle-of-the-night complaints!', author: 'The Martinez Family', location: 'Large Family RVers, Texas' },
        { text: 'Perfect thickness for our over-cab bunk. Finally have clearance and comfort at the same time.', author: 'Derek P.', location: 'Class C Owner, Arizona' },
        { text: 'Used to dread sleeping in the bunk. Now I fight the kids for it! This mattress is surprisingly comfortable.', author: 'Uncle Mike', location: 'Extended Family Trips, Michigan' },
        { text: 'Easy to store when not in use. Lightweight but supportive. Exactly what we needed for our popup.', author: 'Jenny & Mark L.', location: 'Popup Camper, Pennsylvania' },
        { text: 'Great value for a bunk mattress. Kids have been sleeping on these for 2 years with no issues. Still holds up great.', author: 'The Thompson Family', location: 'Weekend Warriors, Indiana' },
        { text: 'Finally, a bunk mattress that doesn\'t feel like sleeping on plywood! The kids love it and so do visiting friends.', author: 'Chris & Dana B.', location: 'Bunkhouse Owners, North Carolina' },
        { text: 'Perfect size for our odd-shaped bunk. Custom fit was easy to order and arrived quickly. Very happy!', author: 'Tammy R.', location: 'Vintage Trailer Owner, California' },
        { text: 'The thin profile is perfect but doesn\'t sacrifice comfort. Exactly what we needed for tight spaces.', author: 'Young Family Adventures', location: 'New RVers, Washington' },
        { text: 'Our teenagers finally stop complaining about the bunk beds. Worth every penny for the family peace!', author: 'Tired Dad Dave', location: 'Family of 6, Ohio' },
        { text: 'Lightweight made installing it on the top bunk super easy. Great quality for the price too.', author: 'Handy Mom Helen', location: 'DIY RVers, Louisiana' }
      ]
    }
  };
  
  var featureIcons = {
    temperature: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/></svg>',
    motion: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 12h8M12 8v8"/></svg>',
    edge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>',
    memory: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    pressure: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>',
    firm: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="8" width="20" height="8" rx="2"/></svg>',
    value: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    cooling: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"/></svg>',
    thin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="9" width="20" height="6" rx="1"/></svg>',
    light: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>'
  };
  
  function showProductLanding() {
    var modal = document.getElementById('productLandingModal');
    var data = productLandingData[S.matt];
    if (!modal || !data) return;
    
    // Hero content - use first image's full size
    var firstImg = data.images && data.images[0] ? data.images[0].full : '';
    document.getElementById('plHeroImg').src = firstImg;
    document.getElementById('plBadgeText').textContent = data.badge;
    document.getElementById('plTitle').textContent = data.name;
    document.getElementById('plSubtitle').textContent = data.subtitle;
    document.getElementById('plDesc').textContent = data.description;
    
    // Thumbnail gallery - use thumb URLs for fast loading, store full URL in data attribute
    var thumbsContainer = document.getElementById('plHeroThumbs');
    if (thumbsContainer && data.images && data.images.length > 1) {
      var thumbsHtml = data.images.map(function(img, i) {
        var activeClass = i === 0 ? ' active' : '';
        return '<div class="pl-hero-thumb' + activeClass + '" data-full="' + img.full + '" onclick="WRVBuilder.setPlImage(this)"><img src="' + img.thumb + '" alt=""></div>';
      }).join('');
      thumbsContainer.innerHTML = thumbsHtml;
      thumbsContainer.style.display = 'flex';
    } else if (thumbsContainer) {
      thumbsContainer.innerHTML = '';
      thumbsContainer.style.display = 'none';
    }
    
    // Stats
    var statsHtml = data.stats.map(function(s) {
      return '<div class="pl-hero-stat"><div class="pl-hero-stat-value">' + s.value + '</div><div class="pl-hero-stat-label">' + s.label + '</div></div>';
    }).join('');
    document.getElementById('plStats').innerHTML = statsHtml;
    
    // Feature name in section header
    var featureName = document.getElementById('plFeatureName');
    if (featureName) featureName.textContent = data.shortName;
    
    // Features grid
    var featuresHtml = data.features.map(function(f) {
      return '<div class="pl-feature-item"><div class="pl-feature-icon">' + (featureIcons[f.icon] || '') + '</div><div class="pl-feature-content"><h4>' + f.title + '</h4><p>' + f.desc + '</p></div></div>';
    }).join('');
    document.getElementById('plFeatures').innerHTML = featuresHtml;
    
    // Layers stack
    var layersHtml = data.layers.map(function(l) {
      return '<div class="pl-layer-item"><div class="pl-layer-depth">' + l.depth + '</div><div class="pl-layer-info"><h5>' + l.name + '</h5><p>' + l.desc + '</p></div></div>';
    }).join('');
    document.getElementById('plLayers').innerHTML = layersHtml;
    
    // Layers details
    document.getElementById('plLayersTitle').textContent = data.layersTitle;
    document.getElementById('plLayersDesc').textContent = data.layersDesc;
    
    // Specs
    var specsHtml = data.specs.map(function(s) {
      return '<div class="pl-spec"><div class="pl-spec-label">' + s.label + '</div><div class="pl-spec-value">' + s.value + '</div></div>';
    }).join('');
    document.getElementById('plSpecs').innerHTML = specsHtml;
    
    // Testimonial carousel
    var testimonials = data.testimonials || [];
    var starSvg = '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    var starsHtml = starSvg + starSvg + starSvg + starSvg + starSvg;
    
    var slidesHtml = testimonials.map(function(t, i) {
      var initials = t.author.split(' ').map(function(n) { return n[0]; }).join('').substring(0,2).toUpperCase();
      var activeClass = i === 0 ? ' active' : '';
      return '<div class="pl-testimonial-slide' + activeClass + '" data-index="' + i + '">' +
        '<div class="pl-testimonial-stars">' + starsHtml + '</div>' +
        '<p class="pl-testimonial-text">"' + t.text + '"</p>' +
        '<div class="pl-testimonial-author">' +
        '<div class="pl-testimonial-avatar">' + initials + '</div>' +
        '<div class="pl-testimonial-info"><div class="pl-testimonial-name">' + t.author + '</div>' +
        '<div class="pl-testimonial-location">' + t.location + '</div></div></div></div>';
    }).join('');
    
    var testimonialHtml = '<div class="pl-testimonial-carousel">' +
      '<button class="pl-testimonial-arrow pl-testimonial-prev" onclick="WRVBuilder.changeTestimonial(-1)"><svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<div class="pl-testimonial-slides">' + slidesHtml + '</div>' +
      '<button class="pl-testimonial-arrow pl-testimonial-next" onclick="WRVBuilder.changeTestimonial(1)"><svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg></button>' +
      '</div>' +
      '<div class="pl-testimonial-dots">' + testimonials.map(function(_, i) {
        return '<span class="pl-testimonial-dot' + (i === 0 ? ' active' : '') + '" onclick="WRVBuilder.goToTestimonial(' + i + ')"></span>';
      }).join('') + '</div>';
    document.getElementById('plTestimonial').innerHTML = testimonialHtml;
    
    // Reset testimonial index
    currentTestimonialIndex = 0;
    
    // CTA name
    var ctaName = document.getElementById('plCtaName');
    if (ctaName) ctaName.textContent = data.name;
    
    var content = modal.querySelector('.pl-content');
    var hero = modal.querySelector('#plHero');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Force scroll to top
    if (content) {
      content.scrollTop = 0;
    }
    setTimeout(function() { 
      if (content) content.scrollTop = 0;
      if (hero) hero.scrollIntoView(true);
    }, 50);
    setTimeout(function() { 
      if (content) content.scrollTop = 0;
    }, 200);
  }
  
  function setPlImage(thumbEl) {
    if (!thumbEl) return;
    var fullSrc = thumbEl.getAttribute('data-full');
    var mainImg = document.getElementById('plHeroImg');
    if (mainImg && fullSrc) mainImg.src = fullSrc;
    
    // Update active state on thumbnails
    var thumbs = document.querySelectorAll('.pl-hero-thumb');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumbEl.classList.add('active');
  }
  
  // Testimonial carousel
  var currentTestimonialIndex = 0;
  
  function changeTestimonial(direction) {
    var slides = document.querySelectorAll('.pl-testimonial-slide');
    var dots = document.querySelectorAll('.pl-testimonial-dot');
    if (!slides.length) return;
    
    currentTestimonialIndex += direction;
    if (currentTestimonialIndex >= slides.length) currentTestimonialIndex = 0;
    if (currentTestimonialIndex < 0) currentTestimonialIndex = slides.length - 1;
    
    slides.forEach(function(s, i) {
      s.classList.toggle('active', i === currentTestimonialIndex);
    });
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === currentTestimonialIndex);
    });
  }
  
  function goToTestimonial(index) {
    var slides = document.querySelectorAll('.pl-testimonial-slide');
    var dots = document.querySelectorAll('.pl-testimonial-dot');
    if (!slides.length || index < 0 || index >= slides.length) return;
    
    currentTestimonialIndex = index;
    slides.forEach(function(s, i) {
      s.classList.toggle('active', i === currentTestimonialIndex);
    });
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === currentTestimonialIndex);
    });
  }
  
  function closeProductLanding(event) {
    var modal = document.getElementById('productLandingModal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  // Reviews Modal - Custom rendering with Stamped API
  var currentReviewPage = 1;
  var reviewsPerPage = 10;
  var totalReviewCount = 0;
  var totalReviewPages = 1;
  var isLoadingReviews = false;
  var currentProductId = null;
  
  var productHandles = {
    montana: 'the-montana-pillowtop',
    aspen: 'the-aspen',
    canyon: 'the-canyon',
    dreambunk: 'wilderness-dream-bunk'
  };
  
  var productTitles = {
    montana: 'Montana Hybrid',
    aspen: 'Aspen',
    canyon: 'Canyon',
    dreambunk: 'Dream Bunk'
  };
  
  function showReviewsModal() {
    var modal = document.getElementById('reviewsModal');
    var data = productLandingData[S.matt];
    if (!modal || !data) return;
    
    // Set title
    document.getElementById('reviewsTitle').textContent = data.name + ' Reviews';
    
    // Get product info
    var handle = productHandles[S.matt];
    currentProductId = window.WRVBuilderConfig && window.WRVBuilderConfig.productIds ? window.WRVBuilderConfig.productIds[handle] : null;
    
    // Reset state
    currentReviewPage = 1;
    
    // Show loading
    var container = document.getElementById('reviewsWidgetContainer');
    if (container) {
      container.innerHTML = '<div class="reviews-loading"><div class="reviews-spinner"></div><p>Loading reviews...</p></div>';
    }
    
    var content = modal.querySelector('.reviews-content');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Scroll content to top
    if (content) {
      content.scrollTop = 0;
      setTimeout(function() { content.scrollTop = 0; }, 50);
    }
    
    // Fetch reviews
    fetchReviews(currentReviewPage);
  }
  
  function fetchReviews(page) {
    if (isLoadingReviews || !currentProductId) return;
    isLoadingReviews = true;
    
    // Stamped public API
    var apiUrl = 'https://stamped.io/api/widget/reviews?storeUrl=wildernessrvmattress.myshopify.com&productId=' + currentProductId + '&page=' + page + '&take=' + reviewsPerPage;
    
    fetch(apiUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('API error');
        return response.json();
      })
      .then(function(data) {
        isLoadingReviews = false;
        
        if (data && data.data) {
          totalReviewCount = data.total || data.count || 0;
          totalReviewPages = Math.ceil(totalReviewCount / reviewsPerPage);
          renderReviews(data);
        } else {
          showReviewsError();
        }
      })
      .catch(function(err) {
        console.error('Failed to fetch reviews:', err);
        isLoadingReviews = false;
        showReviewsError();
      });
  }
  
  function renderReviews(data) {
    var container = document.getElementById('reviewsWidgetContainer');
    if (!container) return;
    
    var reviews = data.data || [];
    var rating = data.rating || 4.9;
    
    // Build star HTML
    function getStars(count) {
      var html = '';
      for (var i = 0; i < 5; i++) {
        if (i < count) {
          html += '<svg class="star filled" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
        } else {
          html += '<svg class="star empty" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
        }
      }
      return html;
    }
    
    // Summary header
    var html = '<div class="reviews-summary-header">' +
      '<div class="reviews-overall">' +
      '<div class="reviews-stars-large">' + getStars(Math.round(rating)) + '</div>' +
      '<p class="reviews-rating-text">' + rating.toFixed(1) + ' out of 5 based on ' + totalReviewCount.toLocaleString() + ' reviews</p>' +
      '</div>' +
      '</div>';
    
    // Reviews list
    html += '<div class="reviews-list">';
    
    if (reviews.length === 0) {
      html += '<p class="reviews-empty">No reviews found.</p>';
    } else {
      for (var i = 0; i < reviews.length; i++) {
        var review = reviews[i];
        var author = review.author || 'Verified Buyer';
        var initials = author.split(' ').map(function(n) { return n[0]; }).join('').substring(0, 2).toUpperCase();
        var reviewRating = review.reviewRating || 5;
        var body = review.reviewMessage || review.body || '';
        var title = review.reviewTitle || '';
        var date = review.reviewDate ? new Date(review.reviewDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
        var location = review.reviewUserLocation || '';
        var isVerified = review.reviewVerifiedType || review.isVerified;
        
        html += '<div class="review-item">';
        html += '<div class="review-header">';
        html += '<div class="review-author-info">';
        html += '<div class="review-avatar">' + initials + '</div>';
        html += '<div class="review-author-details">';
        html += '<span class="review-author-name">' + author + '</span>';
        if (isVerified) {
          html += '<span class="review-verified"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg> Verified Buyer</span>';
        }
        if (location) {
          html += '<span class="review-location">' + location + '</span>';
        }
        html += '</div></div>';
        if (date) {
          html += '<span class="review-date">' + date + '</span>';
        }
        html += '</div>';
        
        html += '<div class="review-rating">' + getStars(reviewRating) + '</div>';
        
        if (title) {
          html += '<h4 class="review-title">' + title + '</h4>';
        }
        
        html += '<p class="review-body">' + body + '</p>';
        html += '</div>';
      }
    }
    
    html += '</div>';
    
    // Pagination
    html += '<div class="reviews-pagination">';
    html += '<button class="reviews-page-btn" onclick="WRVBuilder.changeReviewPage(-1)"' + (currentReviewPage <= 1 ? ' disabled' : '') + '>';
    html += '<svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg> Prev</button>';
    html += '<span class="reviews-page-info">Page ' + currentReviewPage + ' of ' + totalReviewPages + '</span>';
    html += '<button class="reviews-page-btn" onclick="WRVBuilder.changeReviewPage(1)"' + (currentReviewPage >= totalReviewPages ? ' disabled' : '') + '>';
    html += 'Next <svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg></button>';
    html += '</div>';
    
    container.innerHTML = html;
  }
  
  function showReviewsError() {
    var container = document.getElementById('reviewsWidgetContainer');
    if (container) {
      container.innerHTML = '<div class="reviews-error"><p>Unable to load reviews. Please try again later.</p></div>';
    }
  }
  
  function changeReviewPage(direction) {
    var newPage = currentReviewPage + direction;
    if (newPage < 1 || newPage > totalReviewPages) return;
    
    currentReviewPage = newPage;
    
    var container = document.getElementById('reviewsWidgetContainer');
    if (container) {
      container.innerHTML = '<div class="reviews-loading"><div class="reviews-spinner"></div><p>Loading reviews...</p></div>';
    }
    
    fetchReviews(currentReviewPage);
  }
  
  function closeReviewsModal(event) {
    var modal = document.getElementById('reviewsModal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  // Expose to global
  window.WRVBuilder = {
    init: init,
    setView: setView,
    goTo: goTo,
    next: next,
    prev: prev,
    selMatt: selMatt,
    selComf: selComf,
    updDim: updDim,
    adjDim: adjDim,
    setSize: setSize,
    setCornType: setCornType,
    setCornStyleFor: setCornStyleFor,
    updCornDimFor: updCornDimFor,
    adjCornDim: adjCornDim,
    togCornEdit: togCornEdit,
    closeCornEdit: closeCornEdit,
    selHinge: selHinge,
    updHingePos: updHingePos,
    selThick: selThick,
    updThick: updThick,
    adjThick: adjThick,
    updPrev: updPrev,
    addCart: addCart,
    showMeasureHelp: showMeasureHelp,
    closeMeasureHelp: closeMeasureHelp,
    showCornerHelp: showCornerHelp,
    closeCornerHelp: closeCornerHelp,
    showCornerImage: showCornerImage,
    backToCornerOptions: backToCornerOptions,
    showHingeHelp: showHingeHelp,
    closeHingeHelp: closeHingeHelp,
    showHingeImage: showHingeImage,
    backToHingeOptions: backToHingeOptions,
    showProductLanding: showProductLanding,
    setPlImage: setPlImage,
    closeProductLanding: closeProductLanding,
    showReviewsModal: showReviewsModal,
    closeReviewsModal: closeReviewsModal,
    changeReviewPage: changeReviewPage,
    changeTestimonial: changeTestimonial,
    goToTestimonial: goToTestimonial
  };
  
  // Auto-init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
